module.exports = {
  PleaseChooseJob: '注文書を選択してください。',
  NoSearchingInfo: 'クエリ情報が入力されていません。',
  NoRecordMeetTheConditions: '条件を満たすレコードが見つかりませんでした。',
  Error: 'エラー',
  Locked: 'ロックされています',
  UnKnownStatus: '処理状況不明',
  CloseDetailWindow: '詳細ウィンドウを閉じる',
  AdvancedSearch: '高度な検索',
  NoCustomersFoundPleaseRefreshCache: 'お客様が存在しません。キャッシュをリセットしてみてください！',
  SelectedMonthHasBeenClosed: '現在選択されている月は転記が閉じられています。',
  AccountClosedSuccessfully: 'アカウントのクローズに成功しました。',
  PleaseSelectClosingRecord: '会計レコードを選択してください。',
  ClosingRecordHasBeenApproved: '会計記録は監査済みでキャンセルできません。',
  CancelTheClosingRecord: '会計記録をキャンセルしますか？',
  AccountClosingRecordCanceled: '会計レコードがキャンセルされました',
  CannotBeCancelledAfterApproval: '監査後の会計記録はキャンセルできません。よろしいですか？',
  ClosingDateAfterCancelingTheApproval: '監査をキャンセルした後、会計処理日をキャンセルできますが、よろしいですか？',
  BillingType: '請求タイプ',
  ByTicket: '都度',
  InvitationListTip: 'The customer has submitted the feed, and inviting the pair again will unlock the customer\'s feed page and allow the edit to submit again! Do you want to continue?',
  PleaseClickFirst: 'Please click "Confirm order" first.',
  PleaseSelectTheFeeYouNeedToPush: '同期する費用を選択してください',
  PleaseSelectTheFeeYouNeedToCopy: 'コピーする費用を選択してください',
  PleaseSeparateMultipleEmailAddressesWithCommas: '複数のメールアドレスはカンマで区切ってください',
  PleaseSupplementOtherMailboxes: '他のメールボックスを補足してください',
  ContactAndEmailAreNotMaintained: '連絡先とメールボックスが維持されていません',
  PleaseSelectTheMaintainedContactAndMailbox: 'メンテナンスされている連絡先とメールボックスを選択してください',
  SelectMailbox: 'メールボックスの選択',
  InvoiceUuidCannotBeBlank: '請求書uuidは空にできません',
  TheSettlementUnitIDCannotBeEmpty: '決済単位idは空にできません！',
  PleaseEnterYourEmailAddress: 'メールアドレスを入力してください',
  Monthly: '月締め',
  PleaseSelectTheDataYouWantToExport: 'エクスポートするデータをチェックしてください',
  NoData: 'データがありません',
  PleaseSelectJob: 'ビジネスを選択してください。',
  ThisJobIsNotWorkingCanNotBeEdited: 'このシートは操作中の状態ではなく、編集できません',
  CanNotEditJob: '{0}のビジネスは変更できません！',
  TheSameSalesAndOperationsConfirmThatYouWantToSave: '売上と操作内容は同じです。保存しますか？',
  SolicitationTypeIsNotTheSameAsSubBillDoYouWantToSaveIt: '集荷種別がレシートと異なります。保存しますか？',
  WHNoRepeatedContinue: '入庫番号が重複しています。続行しますか？',
  Prompt: 'プロンプト',
  MblNoRepeatedContinue: 'MBL番号が重複しています。保存を確認しますか？',
  MblNoRepeatedNotCurrentCompanyContinue: '入力した番号は現在のビジネスのオペレーション支社または部門に属していません。続行するかどうかを確認してください',
  MblNoRepeatedNotCurrentCompanyContinueAll: '入力したMBLは重複しており、現在のビジネスのオペレーション支社または部門に属していません。続行するかどうかを確認してください',
  MblNoSiRepeatedContinue: 'マスタ番号が重複しています。保存を確認しますか？',
  MblNoRepeatedNotSave: 'MB/LNO.【{0}】重複は保存できません。',
  AlreadyAssociatedWithOtherBranches: '既に他のブランチオフィスが関連付けられています【{0}】。他のパートナーを選択して関連付けしてください！',
  CustomerRefNoRepeatedContinue: 'ビジネス参照番号が重複しています。保存しますか？',
  HblNoRepeatedContinue: 'HBL番号が重複しています。保存を確認しますか？',
  SoNoRepeatedContinue: 'SoNo番号が重複しています。保存しますか？',
  HAWBRepeatedContinue: 'HAWBPartは重複できません',
  HBLRepeatedContinue: 'HBLセクション番号の重複は許可されていません',
  IATACodeRepeat: 'IATA CODE重複不可',
  AirCodeRepeat: '航空会社は繰り返してはならない',
  AuthenticationFailed: '認証に失敗しました！',
  SaveSuccessfully: '保存に成功しました',
  InvoiceNoLength: '請求書番号が長すぎます。チェックしてください',
  Success: '成功',
  ShutOutSuccessfully: 'ログアウト成功',
  CancellationSuccessfully: '廃棄に成功します',
  CancelShutOutSuccessfully: 'キャンセル完了',
  ThisTemplateCouldNotBeResolvedPleaseContactCS: 'このテンプレートを解析できません。カスタマーサービスに連絡してください。',
  CurrentBranchIsNotSelectedCannotAddNewBookings: '現在の支社が選択されていないので、注文書を追加できません。',
  CompanySelectedIsHQCannotAddNewBookings: '会社は本社として選択されているので、注文書を増やすことはできません。',
  TheLastOfTheNewStateHasBeenRestored: '前回の新規状態が復元されました。',
  CancelMotify: '現在の変更をキャンセルしますか？',
  Info: '情報',
  NoBusinessCanBeSplit: '分割できるビジネスがありません。',
  SplittingErrorContainerInformationIsEmpty: '分割エラー、梱包情報が空です。',
  IsNotOperationStatus: '操作中の状態ではありません。',
  SureDelete: '削除しますか？',
  DeleteSuccessfully: '削除に成功しました',
  CustomerIssuing: 'HBLが選択されていないお客様は、HBLタブに行って選択してください',
  CustomerIssuingTips: '保留中/差し押さえ済み、ファイルタイプ「顧客自己請求」のアップロードを続行しますか？',
  DirectBusiness: 'ダイレクトビジネス',
  SplittingBusiness: '注文を分ける',
  NoPermissionToEditTheJob: '約束手形を編集する権限がありません。',
  HaveBusinessHasBeenSubmittedCannotBeShutOut: '選択したレコードに財務監査業務が含まれています。確認してください。',
  HaveBusinessHasBeenShutOuted: '選択したレコードには通関業務が含まれています。チェックしてください。',
  HaveBusinessHasBeenCancellation: '選択した履歴に廃棄業務が含まれていますのでチェックしてください。',
  PleaseRemoveThisTicketFromMblThenShutOutBatch: '選択したチケットをメインチケットから削除して、ログアウトしてください。',
  PleaseRemoveAllTicketsFromMblThenShutOutBatch: '選択したマスタからすべてのチケットを削除してから、ログアウトしてください。',
  HasChargeToShutOutTip: '費用のかかる業務については費用のかかるリワードを行いますが、確認しますか?',
  NoneChargeToShutOutTip: '費用のかからない業務については費用のかからない退出を行いますが、確認しますか?',
  BusinessHasBeenSubmittedCannotBeShutOut: 'ビジネスは財務監査に提出されたため、チェックアウトできません。',
  NoPermissionToCancelTheShutOut: 'あなたにはチェックアウトをキャンセルする権限がありません。',
  ConfirmToCancelTheShutOut: 'キャンセルを確定しますか？',
  Warning: '警告',
  NoChargeToShutOut: '料金なしでログアウト',
  HasChargeToShutOut: '料金の払い戻しがあります',
  PleaseConfirmTheShutOut: 'ログアウトを確認してください？',
  SendStatusChangeNotification: '状態変更通知の送信',
  StatusChangeNotification: '処理状況変更通知（内部）',
  OptionIsChecked: 'このオプションをチェックすると、内外SOP変更通知メールが送信されます',
  OnlyBeUsedForChangingCosts: '費用関連の変更のみ可',
  DoNotMakeAnyChanges: '変更できません（すべての費用が削除されます）',
  IfDoNotClearTheConfirmationFeeDoNotAllowFreeShutOut: '確認された料金をクリアしないと、料金なしでチェックアウトできません。',
  PleaseRemoveThisTicketFromMblThenShutOut: 'このチケットをメインチケットから削除して、チェックアウトしてください。',
  PleaseRemoveAllTicketsFromMblThenShutOut: 'このマスタチケットからすべてのチケットを削除してから、ログアウトしてください。',
  TicketsMustBeVoted: 'チケットはメインチケットに追加する必要があります',
  NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance: '支払費用はすべて監査されていないため、事前に提出できません。',
  CommitSuccessfully: '送信に成功しました。',
  LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL: '箱詰めのレシートは個別に提出できません。メインチケットを提出してください。',
  GenerateExpensesBasedOnCurrentSellingPriceAndBuyingPrice: '現在の売値、買値に基づいて費用を生成しますか？',
  PlatformCodeNotFound: '課金項目にプラットフォームコードA/Fの航空運賃が見つかりません',
  Withdraw: '撤回する',
  AlreadyReturn: '返品されました。',
  AlreadyWithdraw: '取り下げました。',
  ReturnAction: '操作内容を戻します',
  IsConfirm: '確認しますか',
  Return: '戻る',
  BatchReturnSucceeded: '一括返品成功:{0}',
  BatchReturnPreSubmitCheck: '業務状態が事前に提出されたリストだけを返却することができます。',
  BatchReturnSubmitCheck: '業務状態が提出済みのリストだけを取り下げることができます。',
  BusinessIsNotCommittedAndCannotBeWithdrawn: 'The business is not committed and cannot be withdrawn.',
  BusinessIsNotPreCommittedAndCannotBeReturn: 'The business is not pre-committed and cannot be return.',
  BatchUnlockLockedBillsOfAccountsReceivable: '売掛金のロックされたリストのみを一括ロック解除できます！',
  lowBalanceTips: 'You have insufficient balance to recognize all the batch-uploaded customs declaration documents.<br/>You can choose to continue uploading files to the file history, but in this case, the system will not recognize the customs declaration information. This means that the files you upload will be saved but will not be analyzed for customs declaration information.<br/> If you choose to upload after recharge, the system will default to not uploading files and not parsing the customs declarations.',
  lowBalanceTips1: 'Continue to upload files',
  lowBalanceTips2: 'Upload after recharge',
  BatchUnlockLockingBillsOfAccountsReceivable: '売掛金がロック解除されたリストのみを一括ロックできます！',
  BatchUnlockLockingBillsOfAccountsPayable: '一括ロックできるのは、ロック解除された買掛伝票のみです！',
  BatchUnlockLockedBillsOfAccountsPayable: '支払費用のロックされたリストのみを一括ロック解除できます！',
  UnlockChargeStatus: '{0}チャージ処理状況のロック解除を確認しますか？',
  LockingChargeStatus: '{0}チャージ処理状況のロックを確認しますか？',
  SuccessfullyUnlockedFeesInBatch: '一括ロック解除{0}費用成功:{1}',
  SuccessfullylockingedFeesInBatch: '一括ロック{0}費用成功:{1}',
  ThereAreFeesReceivableNotInvoicedPrint: '未請求の売掛金があります。印刷しますか？',
  ThereAreFeesReceivableNotInvoicedSubmit: '未請求の売掛金があります。本当に提出しますか？',
  VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'この業務は財務審査に提出されます。提出する前に、関連ファイルがシステムにアップロードされていることを確認してください。続行しますか？',
  SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'この注文業務は上司に提出されます。提出する前に、関連ファイルがシステムにアップロードされていることを確認してください。続行しますか？',
  PleaseInputTheSalesInformationAndPrints: '営業担当者情報を入力してから印刷してください！',
  PleaseInputTheSalesInformationAndSubmit: '営業担当者情報を入力してから送信してください！',
  FollowingTheSingleDidNotEnterTheSalesInformation: '次のシートには営業担当者情報が入力されていません',
  PleaseEnterAndPrint: '入力してから印刷してください！',
  PleaseSelectAWaterBillRecord: 'Please select a water bill record',
  PleaseEnterAndSubmit: '入力してから送信してください！',
  WithCostsAbroadWithoutValidBillingNumberYouCannotPrintAnAnalysisOfProfitTable: '海外費用があり、有効な請求書番号がないため、利益分析表を印刷できません！',
  WithCostsAbroadWithoutValidBillingNumberCannotBeSubmitted: '有効な請求書番号がない海外費用があり、提出できません！',
  BulkSubmissionOfWrittenSubmissionsOnlyList: '事前に提出されたリストのみを一括提出できます！',
  BulkSubmissionOfWrittenPreSubmissionsOnlyList: '操作中の状態のリストのみを一括して事前に送信できます！',
  MakeSureToSubmitAListOftheNFinancialAuditPlease1: 'これを確認します',
  MakeSureToSubmitAListOftheNFinancialAuditPlease12: 'チケットリストは財務審査に提出しますか？',
  BatchSubmittedSuccessfully: '一括送信に成功しました',
  BatchSubmittedPreSuccessfully: '一括プレコミットが成功しました',
  TheSelectedDocumentInconsistentNatureOfTheBooking: '選択したドキュメントの価格の性質が一緻しません',
  TheSelectedDocumentIsNotTheSameVoyage: '選択したドキュメントは同じ航海/船名ではありません',
  SelectTheData: 'データを選択してください',
  NoSelectedDataOrAreNotOperationalStatus: 'データが選択されていないか、操作中ではありません',
  TheSelectedServicesIncludeLockedServices: '選択された業務にはロックされている業務が含まれています',
  SureYouWantToRemoveTheCharge: '本当に料金を削除しますか？',
  NoCostToRemove: '削除できる費用はありません。',
  NoBusinessOrIsNotOperationalState: 'ビジネスが選択されていないか、アクティブな状態ではありません。',
  MakeSureToDelegateTheBusiness: 'このチケット業務を委託してもよろしいですか？',
  ErrorReadingInformation: '情報の読み取り中にエラーが発生しました。',
  OrderTypeChangeTip: '注文タイプを切り替えると、一部の記入済みデータがクリアされます。切り替えを確認しますか？',
  BusinessDateCanNotNull: '取引日は空にできません',
  TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners: '受取人はパートナーで現在の会社情報を維持していません',
  ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain: 'この業務はすでに電子委託を送信しましたが、再度送信しますか？',
  DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize: '対応するテンプレートタイプ【BOOKING】とテンプレート名【海運輸出貨物委託書】が見つかりません。委託を続行しますか？',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: '現在、予約代理店が所属する支社は、パートナーの中で当社に対応するパートナーを維持していません',
  TheBranchCompanyOfCurrentForwardingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: '現在、出荷代理店が所属する支社は、パートナーの中で当社に対応するパートナーを維持していません',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI: '現在の目的港代理の所属支社は、パートナーの中で当社に対応するパートナーを維持していません',
  TheBranchCompanyOfUnExchangeAgent: '現在の交換エージェントの所属支社は、パートナー内で自社のパートナーを維持していません',
  TheBranchCompanyOfUnOurCompany: '現在の運送会社の所属支社では、パートナー内で自社のパートナーを維持していません',
  TheOppositeSideHasScceptedNoNeedToReCommission: '相手は受理したので、再依頼する必要はありません！',
  SuccessfullySent: '送信に成功しました。',
  NoSendingGoodsInfo: 'There is no cargo information that needs to be sent.',
  NoAssociatedBusiness: '発送する必要のある貨物情報は存在しません',
  NoAssociatedContainerInfo: '送信可能な梱包情報がありません',
  PleaseEnterFleetInformatio: 'フリート情報を入力してください',
  ThisBoxIsNotAllowedToBeDeleted: 'このボックスは削除できません',
  FailedToQueryTheAssociatedBusiness: '関連ビジネスが見つかりませんでした。',
  RepeatedWarehouseNo: '倉庫番号が重複しています',
  NoStorageInfo: '入庫情報がありません',
  TheJobIsIncorrectPleaseRefreshThePageOrContactTheAdministrator: '作業指示が正しくありません。ページを更新するか、管理者に連絡してください！',
  ConsignationCompanyCannotBeNull: '委任先は空にできません',
  FLCLTypeCannotBeNull: '完全型は空にできません',
  POLCannotBeNull: '出発港は空にできません',
  IfThereIsATransferTheTransferPortCannotBeNull: '中継がある場合、中継港は空にできません',
  PortOfDischargeCannotBeNull: '荷揚げ港は空にできません',
  PortOfDestinationCannotBeNull: '宛先港は空にできません',
  SalesCannotBeNull: '売上は空にできません',
  SalesBranchCompanyIsNullPleaseReSelectSales: '営業部門が空です。営業部門を再選択してください！',
  SalesDepartmentIsNullPleaseReSelectSales: '営業部門を選択してください！',
  DateOfDepartureCannotBeLaterThanDateOfArrival: '出航日は到着日より遅くすることはできません',
  NominatedAgentCannotBeNull: '指定貨物エージェントは空にできません！',
  FLCLTypeCannotBeNull2: 'パッキングタイプは空にできません！',
  ItemNoCannotBeNull: 'プロジェクト番号は空にできません！',
  EQSizeCannotBeNull: '箱型は空にできません！',
  EQSizeCannotBeNull2: 'There must be at least one box!',
  DearYouCanOnlySelectYourOwnCustomers: '親、自分のお客様しか選択できませんよ。',
  DepartmentCannotBeNull: '部門は空にできません。',
  CyCutoffDateCannotBeLaterThanDepartureDate: '締切日は出航日より大きくできません',
  BargeCutoffDateCannotBeLaterThanCyCutoffDate: 'バージの締切日は締切日より大きくできません！',
  ContainerSealInfoHasBeenEnteredCannotBeDeleted: '関連するエンクロージャ情報が入力されました。削除できません。',
  RelevantInstallationInfoHasBeenEnteredCannotBeDeleted: '関連するボード情報が入力されています。削除することはできません。',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated: '請求重量が変更されました。元の請求重量単位の料金を更新しますか？請求書を作成しました、請求された費用は更新されません。',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated2: '請求重量が変更されました。元の請求重量単位の料金を更新しますか？請求書を作成しました、請求、支払申請、消込済の費用は更新されません。',
  CurrencyChangeConfirm: '買価/売価通貨が変更されました。既存の費用を更新しますか？請求書発行、インボイス、支払申請、消込済みの費用は更新されません',
  PriceTypeChangeConfirm: '買価/売価タイプが変更されました。既存の費用を更新しますか？請求書発行、インボイス、支払申請、消込済みの費用は更新されません',
  PriceUpdateConfirm: '買値 / 売値が変更されました。売買価格の単位を課金重量とする費用を更新するか確認してください。請求書、請求書発行、支払申請、消込みが完了した費用は更新されません ',
  TheChargedWeightHasBeenChanged: '請求重量が変更されました。元の請求重量単位の料金を更新しますか？',
  WeightChangeToRefreshCostBasedOnWeightPrice: '重量が変更されました。従来の重量価格単位の料金を更新しますか？請求書、請求書、請求書、請求書、請求書、関連請求書を作成した費用は更新されません。',
  WeightChangeToRefreshCostBasedOnWeightTonPrice: '重量が変更されました。従来の重量価格（トン）単位の費用を更新しますか？請求書、請求書、請求書、請求書、関連請求書を作成した費用は更新されません。',
  CubageChangeToRefreshCostBasedOnCubagePrice: '体積が変更されました。元の体積価格単位の費用を更新しますか？請求書、請求書、請求書、請求書、請求書、関連請求書を作成した費用は更新されません。',
  InsideQuantityChangeToRefreshCostBasedOnCubagePrice: '体積が変更されました。元の体積価格単位の費用を更新しますか？請求書、請求書、請求書、請求書、請求書、関連請求書を作成した費用は更新されません。',
  ChangeToRefreshCostBasedOnCubagePrice: '小品件数、重量、体積、課金重量に変更が発生しましたが、小品数、重量価格、体積価格、課金重量価格単位の元の費用を更新しますか？請求書、請求書、請求書、請求書、請求書、関連請求書を作成した費用は更新されません。',
  DistributedSuccessfully: '配送成功',
  BusinessReferenceNoReduplicated: 'ビジネス参照番号が重複しています',
  BookingAgentCannotBeNull: '予約エージェントは空にできません',
  DateOfDepartureCannotBeNull: '出航日は空にできません',
  TheMainInterfaceDoesNotExist: 'メインインタフェースが存在しません',
  FeesHaveBeenUsedForThisUnit: 'この単位にはすでに費用が使用されています。関連する費用の単位を調整してから削除してください！',
  TheChargingUnitIsUsedByAnExistingChargePlan: 'この課金単位を使用している料金プランがあります。関連する料金プランの単位を調整してから削除してください',
  TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst: 'ボックスマスタのビジネス番号はまだ生成されていません。まずマスタを保存してください。.',
  TheSubBillHasBeenConsolidatedAndCannotBeRemoved: 'このレシートは箱詰めされているので、移動できません。',
  PleaseSelectSubBills: 'レシートを選択してください。',
  PleaseSaveTheChangedDataOrExitTheEditStateAndThenCloseTheModule: '変更されたデータを保存するか、編集状態を終了してからモジュールを閉じてください。',
  MblNoIsNull: 'MB/LNoが空です',
  SONoIsNull: 'S/ONoが空です',
  NoVesselVoyageInformation: '船名航海情報なし',
  ObtainSuccessfully: '取得に成功しました',
  PleaseSelectCopyType: 'コピータイプを選択してください.',
  NoTargetShippingCompanyFoundHerePleaseRefreshTheCache: 'この船会社が見つかりません。キャッシュを更新してください！',
  BlIsConfirmed: '船荷証券が確認されました。',
  ThisHblIsCombinedAndCannotBeEdited1: 'このチケットHBLは既に組み込まれています',
  ThisHblIsCombinedAndCannotBeEdited2: '編集不可.',
  ToOrederBlCannotBeTelexReleased: 'TOORDERは放電できません',
  PleaseInputBlSerialNumberFirst: '船荷証券の通し番号を先に入力してください！',
  PleaseSelectTheListToBeMergedInto: '組み込むリストを選択してください！',
  PleaseInputBussinessNo: '業務番号を入力してください！',
  NoSelectedContainerInformation: '梱包情報が選択されていません。',
  PleaseSelectData: 'データをチェックしてください',
  OnlySelectOneData: 'Only select one data',
  Count: '票数',
  AreYouSureYouWantToRemoveTheSubBill: 'レシートを削除しますか？',
  RemovedSuccesfully: '削除に成功しました。',
  NoSubBillsToSplit: '分割可能なレシートはありません。',
  SoNoCannotBeNull: '注文番号（S/O）は空にできません。',
  CancelTheCurrentQuery: '現在のクエリをキャンセル？',
  SelectTheOrderYouWantToJoin: '参加する予約を選択してください。',
  HasJoinIntoMbl: 'マスタに追加されました.',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue: '新規チケットの船名、フライト、輸送業者、予約代理店、目的港代理店、ETD、ETA、倉庫情報はメインチケットと一緻しません。システムはレシートを修正します。続行しますか？',
  ContainerNoDoesNotComplyWithTheNumberingRules: 'ボックス番号が採番規則に適合しません。',
  SealNoHasBeenChanged: '封号は変更されました。',
  PleaseSelectTheDesiredPrintVgm: '印刷するVGMを選択してください。',
  DeleteTheVgmInformation: 'このVGM情報を削除しますか？',
  PleaseEnterEnglish: '英語を入力してください。',
  PleaseEnterTheShippingCompanyInformation: '運送費があります。運送会社情報を入力してください！',
  SameJobtruckOrderNo: 'ドアとドアの箱詰め車の番号が重複しているので、修正してください！',
  SureYouRemoveThisNData1: 'これを削除してもいいですか',
  SureYouRemoveThisNData2: 'データはありますか？',
  AreYouSureYouWantToSendACarOrder: '本当に配車依頼書を送りますか？',
  AreYouSureYouWantToModifyACarOrder: '本当にディスパッチを変更しますか？',
  AreYouSureYouWantToRevokeACarOrder: '本当にキャンセルしますか？',
  ThisCarOrderIsSended: 'ディスパッチが成功した後は、再度ディスパッチすることはできません。注文変更による変更要求のみが可能です。',
  ThisCarOrderCanOnlyBeModifiedAfterSending: '注文後に変更できます。',
  ThisCarOrderIsSendedNoAddUsage: '一票の配車が成功した後、ロッカーを追加することはできません。',
  ThisCarOrderCanOnlyBeRevokedIsUnApproved: 'キャンセルできるのは未受注状態のみです。',
  ThisCarOrderIsChanged: 'ヒント:入荷データが変更されました',
  DeleteFailed: '削除に失敗しました',
  Failure: '失敗',
  DispatchSuccess: 'ディスパッチが成功しました',
  ModifiedTruckOrderSuccess: '注文変更に成功しました',
  RevokeTruckOrderSuccess: '注文取り消し成功',
  DispatchFailed: 'ディスパッチに異常がありました',
  ModefiedTruckOrderFaild: '変更に異常がありました',
  RevokeTruckOrderFaild: '注文の取り消しに異常がありました',
  VgmWeightingMethod: 'VGM計量方式',
  LdpWarn: '冷凍品の場合、少なくとも1行が同時に必須',
  WxpWarn: '危険物の場合、少なくとも1行が同時に必須',
  Transfer: '船代船変更',
  ReasonForDeletion: '削除理由',
  ReasonForDeletionNotEmpty: '削除理由は必須です',
  VesselRegex: '英数字のみ、35文字以内',
  BlNumberRegex: '数字のみ',
  DanClass: '1〜9.9の範囲',
  CubageRegex: '0.001〜2000.999の範囲',
  RowPrefix: '通関番号{0}',
  UpdateVesselVoyNo: '船名航次を修正',
  UpdateVesselVoyNoError: '送信に失敗したマニフェストは船名航次を変更できません',
  InputVesselVoyNo: '更新後の船名航次を入力してください',
  ShipNotRegistered: '船舶が未登録です',
  LoadManifest: 'マニフェストを読み込む',
  ModificationFailed2: '再積付失敗',
  ModifiedSuccessfully: '再積付成功',
  NoDelete: '削除用マニフェスト送信可能なデータがありません',
  SendFailed: '送信に失敗しました',
  SaveFailed: '保存に失敗しました',
  ViewWarehouseEntryPhotos: '倉庫に入る写真を見る',
  DistributeFailedNoFoundRelatedStorageRecord: '配付に失敗しました。対応する倉庫レコードが見つかりませんでした！',
  SureYouWantToCancelTheBindingToTheStorageData: '倉庫データとのバインドを解除しますか？',
  QueryFailed: 'クエリが失敗しました',
  SelectDeclarations: '申告書を選択してください。',
  SelectCustomsInformation: '通関情報を選択してください。',
  SelectCustomsRecord: '通関記録を選択してください。',
  TheNumberOfTenBitCodeYouEnteredIsNotEnough: 'ああ、入力した10桁のコードの桁数が足りません。',
  OperatingCompanyCannotBeNull: '営業単位は空にできません。',
  DateOfCustomsDeclarationCannotBeNull: '通関日は空にできません。',
  PleaseSelectStatusOfCustomsDeclaration: '通関処理状況を選択してください。',
  CargoDetailsWEIGHTBannotBeNull: '貨物明細-WEIGHTは空にできません',
  CargoDetailsAMOUNTBannotBeNull: '貨物明細-AMOUNTは空にできません',
  CargoDetailsCustomsDutyRateBannotBeNull: '貨物明細-関税率は空にできません',
  CargoDetailsCustomsDutiesBannotBeNull: '貨物明細-関税は空にできません',
  CargoDetailsIncrementRateCannotBeNull: '商品明細-VAT税率は空にできません',
  CargoDetailsIncrementValueDutyBannotBeNull: '商品明細-VATは空にできません',
  CargoDetailsConsumptionDutyRateBannotBeNull: '商品明細-消費税率は空にできません',
  CargoDetailsConsumptionDutyBannotBeNull: '貨物明細-消費税は空にできません',
  CargoDetailsCurrencyBannotBeNull: '商品明細-通貨は空にできません',
  CargoDetailsExchangeBannotBeNull: '商品明細-為替レートは空にできません',
  CargoDetailsCargoPriceBannotBeNull: '貨物明細-貨物価格は空にできません',
  CargoDetailsTaxBannotBeNull: '貨物明細-税金は空にできません',
  CargoDetailsTaxRateBannotBeNull: '貨物明細-税率は空にできません',
  ImportSuccessful1: 'インポート成功',
  ImportSuccessful2: ' item',
  ImportFailed: 'インポートに失敗しました',
  CargoDetailsIsNotSelected: '商品の詳細が選択されていません。',
  PleaseSelectUnRelatedTradeDetailData: '関連付けられていない貨物情報を選択してください',
  SelectTheBillingObject: '決算対象を選択',
  NoChargeForTheSettlementOfDomesticObjects: '国内の決済対象となる費用はありません。',
  CancelAudit: ' 監査取消',
  ChargesAudit: '費用の監査',
  ThereAreFeesCantBeDeletedPleaseRecheck: '削除できない費用が含まれています。チェックしてください。',
  TheChargesHaveBeenSettledByFinancialAccountAndCannotBeAmended: '費用は決算済みで、変更できません。.',
  RedChargeOrRedChargedCannotBeEditAdjustAgainPleaseSelectNewAdjustment: '赤消し費用または赤消し費用は再調整できません。調整を追加することを選択してください。',
  RedChargeOrRedChargedCannotBeDeletedPleaseReselect: 'レッドチャージまたはレッドチャージされたチャージは削除できません。再選択してください。',
  PleaseRefresh: '料金は他の人によって変更されました。更新してください',
  ChargeItemCannotBeNull: '費用名は空にできません！',
  MeasureCannotBeNull: '費用の単位は空にできません！',
  SettlementPartyCannotBeNull: '決済対象は空にできません！',
  CurrencyCannotBeNull: '通貨は空にできません！',
  AmountCannotBeNull: '数量は空にできません！',
  UnitRateCannotBeNull: 'Unit rate cannot be null!',
  CustomsSeclarationServiceIsNotSelectedInBookingCannotAdd: '予約クラスに通関サービスが選択されていないため、追加できません:',
  WaerhouseServiceIsNotSelectedInBookingCannotAdd: '予約クラスに倉庫サービスが選択されていないため、追加できません:',
  HaulageServiceIsNotSelectedInBookingCannotAdd: '予約クラスに輸送サービスが選択されていないため、追加できません:',
  ChargeIsNotSelectedOrAllChargesSubmit: 'チャージが選択されていないか、すべて送信されました。',
  ChargeIsNotSelectedOrNotInTheSubmissionStatus: '料金が選択されていないか、提出状態ではありません。',
  OperationSuccessfully: '操作が成功しました',
  PayablesIsNull: '未払費用金額が空です。',
  ReceivalbeIsNull: '売掛金が空です。',
  CopyThePayablesSuccessfullyTotallyOfNItems1: '支払手数料のコピーが成功し、発生しました',
  CopyThePayablesSuccessfullyTotallyOfNItems2: 'ペン料金',
  CopyTheReceivablesSuccessfullyTotallyOfNItems1: '売掛金の転記に成功し、発生しました',
  CopyTheReceivablesSuccessfullyTotallyOfNItems2: 'ペン料金',
  NoPayablesCanBeCopiedThereMayBeSameChargeItems: '対応する費用はコピーできません。同じ費用名が存在する可能性があります。',
  NoReceivablesCanBeCopiedThereMayBeSameChargeItems: 'コピーできる売掛金はありません。同じ費用名が存在する可能性があります。',
  CopyChargeSuccessfullyTotallyOfNItems1: '抄録費用が成功し、発生しました',
  NoChargeCanBeCopiedThereMayBeSameChargeItems: 'コピーできる費用はありません。同じ費用名が存在する可能性があります。',
  TheCurrentlyRelevantBusinessInformationIsNull: '現在関連付けられているビジネス情報は空です。',
  PleaseSelectCharges: '料金を選択してください',
  SelectChargesAreInControl: '選択された料金が管理されています',
  SelectedChargesAreCancelledControlling: '選択された料金はキャンセルされました',
  PleaseGoToTheFCLFreightInquiryModuleToCheckFreightDetails: '箱全体の運賃検索モジュールに行って運賃の詳細を確認してください！',
  PleaseGoToTheAirFreightInquiryModuleToCheckFreightDetails: '空輸運賃照会モジュールに行って運賃の詳細を確認してください！',
  DoYouNeedToInviteOthersToConfirmTheCharges: '招待確認料金は必要ですか？',
  TheMailHasBeenSentPleaseNoteAndHaveACheck: 'メールが送信されました。お問い合わせください！',
  PleaseSelectReceivableCharges: '売掛金を選択してください',
  PleaseSelectPayableCharges: '買掛金を選択してください',
  OnlyAuditChargesHaveBeenSubmitted: '提出された費用のみを監査できます',
  NoChargesToAudit: '監査する費用がありません。費用監査人または費用処理状況を確認してください',
  NoChargesToUnAudit: '監査をキャンセルする必要がある費用はありません。費用監査人または費用処理状況を確認してください',
  NoChargesToReject: '却下する費用はありません。費用レビュー担当者または費用処理状況を確認してください',
  YouAreNotACostSpecifiedByTheReviewerCannotAuditTheCharges: 'すべての費用の監査人であることを確認してください',
  SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill: '選択した費用にはすべての消込済費用が含まれています。請求書に追加しますか？',
  AllSelectedFeesWillBeVerifiedPleaseChooseAgain: '選択した費用はすべて消し込まれているので、再選択してください',
  IncludeFullyWrittenOffCosts: '選択した費用に全額消込済みの金額が含まれています。インボイスに追加しますか？',
  AuditSuccessfully: '監査が成功しました',
  CancelSuccessfully: 'キャンセルに成功しました',
  PleaseSelect1ChargeDetail: '費用の詳細を選択してください。',
  NoPriceToMeetTheQueryCriteria: '該当する価格は検索されませんでした。',
  Prepaid: '前払い',
  Collect: '着払い',
  PrePayTheSamePrice: '前払い同価格',
  RefreshRateFailed: '運賃の更新に失敗しました！',
  PleaseSelectThePrice: '価格を選択してください！',
  Invalidation: '失効',
  Normal: '正常',
  suspension: '欠航',
  NoPickingUp: '出ません',
  Inquiry: '引き合い',
  Tension: '緊張',
  OverStowage: '爆倉',
  CreateBill: '費用通貨別に請求書を作成する',
  SplitBill: '元の通貨別に分割して請求書を生成',
  PleaseBeNotedThatThisRateIsUnderSuspendSailing: '運賃が欠航状態にあることに注意してください！',
  PleaseBeNotedThatThisRateIsUnavailableNow: '運賃が接続されていないことに注意してください！',
  PleaseBeNotedThatThisRateIsOnlyForPartOfEQType: 'この運賃部分は箱型が出ないことに注意してください！',
  PleaseBeNotedThatThisRateIsUnderOverbookedStatus: '運賃が爆倉状態にあることに注意してください！',
  TheOriginOfSelectedRateIsDifferentFromBookingAgent: '選択された価格の運送料ソースは、作業指示の予約エージェントとは異なります',
  Unconfirmed: '未確認です',
  Confirmed: '確認しました',
  Receivable: '売掛金',
  Payable: '支払済み',
  Bill: '請求書',
  TheBillDoesNotConfirm: '請求書は確認されていません',
  SureYouWantToCancel: '本当にキャンセルしますか？',
  StateModifiedSuccessfully: '処理状況の変更に成功しました。',
  NoInternalCostsToBilling: '請求可能な国内費用はありません',
  NoSettlementUnit: '決算単位.',
  CheckoutObjectIsNullNoAdditionalCostsConfirmationSlip: '決済対象が空なので、費用確認書を追加できません。',
  ClearingUpInvoicingInformationWasNotSuccessfullyRead: '決済対象請求先情報の読み取りに失敗しました。',
  YouDontHavePermissionToEditBills: '買掛伝票を編集する権限がありません。',
  YouDontHavePermissionToDeleteBills: '買掛伝票を削除する権限がありません。',
  HaveNoPermissionToDeleteBillsCreatedByOtherUsers: '他のユーザーが作成した請求書を削除する権限はありません',
  NoSelectedBill: '請求書が選択されていません。',
  ClearingTheObjectDoesNotExistPleaseTryResettingTheCache: '決済オブジェクトが存在しません。キャッシュをリセットしてみてください。',
  BillSaveSuccessfully: '請求書の保存に成功しました',
  BillingObjectIsNull: '請求書オブジェクトが空です。',
  ChargeCannotBeEmpty: 'チャージは空にできません。',
  TaxesAndTaxRatesDoesNotMatchTheData: '税額と税率のデータが一緻しません。',
  InvoicingHeadCannotBeEmpty: '請求ヘッダーは空にできません',
  CurrencyExchangeRateIsNotMaintained1: '通貨',
  CurrencyExchangeRateIsNotMaintained2: '為替レートは維持されていません。',
  FeeCurrencyMustBeTheSame: '費用通貨は同じでなければなりません。',
  NoForeignFeeBilling: '請求可能な海外費用はありません。',
  ThisJobIsNotWorkingCanNotBeDeleted: 'このシートは操作中の状態ではないので、削除できません。',
  SureYouWantToDeleteTheBilling: 'この請求書を削除しますか？',
  SureAuditTheBill: 'この請求書を確認しますか？',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided: 'この請求書は財務審査に提出されたので、破棄できません。',
  ThisOrderHasBeenRevokedNotARepeatedAction: 'このオーダーは無効化されているため、繰り返し実行できません。',
  DomesticBillsCannotBeVoided: '国内請求書は無効にできません',
  TheBillHasBeenConfirmedAndCannotBeVoided: '請求書は確認済みで、無効化できません。無効化する場合は、まず確認をキャンセルしてください',
  ThisVerificationHasBeenDoneAndCannotBeVoided: 'この注文はすでに適用されているので、破棄できません。',
  AccountIsClosedAnyOperationIsNotAllowed: 'アカウントはクローズされました。操作は許可されていません',
  ThisFormIsLockedAndCannotBeVoided: 'このフォームはロックされているので無効にできません',
  ThisFormIsLockedAndBillingGroup: 'This form is locked and billing group',
  ConfirmTheCancellationOfTheBill: 'この請求書を無効にしますか？',
  ConfirmTheCancellationOfTheBill2: 'Are you sure to void the selected bill?',
  TheBillHasBeenRevoked: '請求書は無効になりました。',
  NoSelectSettlement: '決済対象が選択されていません.',
  BillOfExchangeCannotBeEmpty: '請求レートは空にできません',
  CollectingAdvanceBillingAndGeneralExpensesCannotBeTogether: '立て替え払いと通常の費用を一緒に請求することはできません。',
  TheBillNumberIsCreatedSuccessfully: '請求書番号が作成されました',
  TheWordCorrespondingNetworkNameOrTheOverseasAgentNetworkManagementCodeHasNotBeenMaintained: '海外エージェントに対応するネットワーク管理者名またはネットワーク管理者の2文字コードはまだ維持されていません。請求書番号を生成できません！',
  EnterTheShareProportion: '割合を入力してください.',
  PleaseSelectACurrency: '割合を入力してください',
  PleaseEnterTheBillingObject: '決済対象を入力してください。',
  PleaseAddCosts: '費用を追加してください.',
  TheAmountOfBillCannotBeEqualTo: '請求金額は0にはなりません',
  PleaseEnterTheNameOfTheCosts: '費用名を入力してください。',
  PleaseEnterTheQuantityOfTheCosts: '費用の数量を入力してください。',
  PleaseEnterThePriceOfTheCosts: '費用単価を入力してください。',
  PleaseSelectTheCostToRemove: '削除する費用を選択してください。',
  CollectingInconsistentWithTheTotalAdvance: '代収と立替総額が一緻しません！',
  TheBillHasBeenInvoicedAndCannotBeDeleted: 'この請求書は請求済みで削除できません',
  LoadFailed: 'ロードに失敗しました',
  PlatformCodeAlreadyExists: 'プラットフォームコードはすでに存在します！',
  NameCannotBeRepeated: '有料科目の氏名または英語名は重複できません！！！',
  ChineseNameCannotBeBlank: '有料科目の氏名は空にできません！！！',
  CannotBeModified: 'ビジネスで使用されているため、名前を変更できません',
  PleaseSelectAServiceItem: 'サービス項目を選択してください',
  Overseas: '海外',
  Domestic: '国内',
  PleaseSelectTheDesiredPrintInformation: '印刷する情報を選択してください',
  ThereIsAnErrorReadingWriteOffInformation: 'リボケーションリスト情報の読み取りエラー',
  TheBookingDoesNotExistAndCannotBeAdded: '注文書が存在しないので、追加できません。',
  PleaseEnter: '少なくとも2文字入力してからクエリを開始してください',
  PleaseEnterTheCode: 'コード、名前などの曖昧なクエリを入力してください...',
  PleaseEnterTheCode2: 'コード、名前などのあいまいなクエリ（少なくとも2文字）を入力してください...',
  PleaseEnterTheContent: '内容を入力してください',
  PleaseSelectDataBeforeOperation: 'データを選択してから操作してください',
  NoPortRecordMeeting: '該当するポートレコードが選択されていません。再選択してください！',
  DeleteTheSelectedRecord: '選択したレコードを削除するかどうか',
  DoYouConfirmThatYouWantToDelete: '削除しますか？',
  DeletionCancelled: '削除がキャンセルされました',
  EditCancelled: '編集がキャンセルされました',
  PleaseSelectARecordToEdit: '編集するレコードを選択してください',
  PleaseFillInTheCorrectFiveDigitPortCode: '正しい港の5桁のコードを記入してください。',
  DeleteFail: '削除に失敗しました！',
  DeleteSucceeded: '削除に成功しました！',
  DisplayRuleCannotBeEmpty: '表示ルールは空にできません！',
  OperationRequirementsCannotBeEmpty: '操作内容要求は空にできません！',
  OperationRequirementsCannotBeGreaterThan: '操作には2048ビット以上の長さが必要です！',
  NewPortRequestSucceeded: '新規ポート要求が成功しました',
  EditPortRequestSucceeded: '港要求の変更に成功しました',
  ConfirmDelete: '削除の確認',
  IsItUsedForMAWB: 'MAWBに使用するかどうか',
  IsItUsedForHAWB: 'HAWBに使用するかどうか',
  AddPortRequirementsAirport: 'ポート要求（空港）を追加',
  EditPortRequirementsAirport: 'ポート要求（空港）の編集',
  PleaseSelectARecordToDelete: '削除するレコードを選択してください',
  BackPageTip: 'Returning to the previous page will delete the information you have entered on the insurance application page. Are you sure you want to go back',
  WarmReminder: 'Warm Reminder',
  GoBack: 'Go Back',
  ReturnToHomepage: 'トップページに戻る',
  HomepageNotSupportImport: 'The homepage of freight insurance does not currently support importing insurance directly',
  PortInformationEditedSuccessfully: '港情報の編集に成功しました',
  AirlineInformationEditedSuccessfully: '航空会社情報の編集に成功しました',
  SuccessfullyAddedAirlineInformation: '航空会社情報の追加に成功しました',
  SuccessfullyAddedPortInformation: '港情報の追加に成功しました',
  GetBack: '取り込み',
  FailedToInquiryCustomsDeclarationInformation: '通関情報のクエリに失敗しました:',
  PleaseSelectARecord: 'レコードを選択してください。',
  NewDocuments: '新規ドキュメント',
  EditDocuments: 'ドキュメントの編集',
  FileTypeCannotBeEmpty: 'ファイルタイプは空にできません！',
  FileNumberCannotBeEmpty: 'ファイル番号は空にできません',
  FileNumberAlreadyExists: 'ファイル番号は既に存在します。',
  DataEnabledSuccessfully: 'データの有効化に成功しました。',
  DataDisabledSuccessfully: 'データの無効化に成功しました。',
  Error2: 'エラー',
  TheDocumentHasBeenSaved: 'ドキュメントが保存されました',
  TheCustomsBrokerCannotBeEmpty: '通関行は空にできません。',
  NoInformationCanBeQueried: '通関情報がありません。',
  ErrorSavingBusinessState: 'ビジネス状態の保存エラー',
  OrderInformationWasSuccessfullyUpdated: '注文情報の更新に成功しました。',
  NoExternalUpdateInformation: '外部更新情報がありません',
  ExternalInformationWasSuccessfullyUpdated: '外部情報の更新に成功しました',
  NodeStatusIsNotPreserved: 'ノード状態は保存されていません。',
  TheNodeAffinityForTheMailTemplateIsNotMaintained: 'ノード関連のメールテンプレートは維持されていません。',
  DoNotLocateAnAssociatedPrintTemplateType: '関連付けられた印刷テンプレートタイプが見つかりません。',
  TheEmailWasSentPleaseNoteTheQuery: 'メールが送信されました。お問い合わせください！',
  PleaseSelectAFile: 'ファイルを選択してください！',
  SureYouWantToDeleteFiles: '本当にファイルを削除しますか？',
  EmailAddressCannotBeEmpty: 'メールアドレスは空にできません。',
  UploadSuccess: 'アップロード成功:',
  UploadFailed: 'アップロードに失敗しました:',
  FileSizeExceedsMBYouCannotUpload: '個のファイルのサイズが20MBを超えているため、アップロードできません。',
  DoNotSelectedCategory: 'ファイルカテゴリが選択されていません。',
  PleaseSelectAJob: 'シートを選択してください。',
  PleaseSelectTheSameTypeOfJob: '同じタイプの作業指示を選択してください',
  NotStart: '開始されていません',
  PleaseSelectABusinessStatus: 'ビジネス処理状況を選択してください',
  PleaseSelectABusinessStatusDetails: 'ビジネス・処理状況の詳細を選択してください',
  EditedSuccessfully: '変更に成功しました',
  PleaseContactTheSuperiorUnlocked: '信管超過のため、本券はロックされて印刷できません。上級者に連絡してロックを解除してください！',
  CanSuccessfullyPrint: '印刷は成功しましたか？',
  ConfirmToPrint: '印刷の確認',
  CorrespondsToThePrintTemplateDoesNotFind: '対応する印刷テンプレートが見つかりません',
  FailedToGetTheTemplateType: 'テンプレートタイプの取得に失敗しました！',
  NoSelectedTemplate: 'テンプレートが選択されていません。',
  BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow: 'バルク転送が成功しました。ポップアップウィンドウを閉じますか',
  BulkTranferSuccessWhetherYouWantToCloseThePopUpWindow: '一括乗り換えに成功しました。ポップアップウィンドウを閉じますか',
  NoFeesCanBeDeleted: '削除する費用はありません。',
  NoSelectedCharge: 'チャージが選択されていません。',
  NoChargeCanBeSaved: '保存できる費用はありません。',
  ChargeNameCannotBeEmpty: 'チャージ名は空にできません。',
  ClearingTheObjectCannotBeNull: '決済オブジェクトは空にできません。',
  BusinessNumberIs0: '業務番号の数は0.',
  CustomerIsNULL: '顧客が空です',
  TheCarrierIsEmpty: '輸送業者が空です。',
  AgentIsNULL: '予約エージェント/交換エージェントが空です。',
  AgentIsNULL2: '海外エージェント/宛先ポートエージェントが空です。',
  CustomsIsNull: '通関行が空、',
  TerminalCompanyIsNull: 'ターミナル会社が空です,',
  TheObjectCannotBeUsedAsTheDefaultSettlement: 'デフォルトの決済対象にはなりません。',
  AddSuccessfully: '新規追加に成功しました。',
  DisplaysTheCostOfUpdatingResults: '費用の更新結菓を表示',
  TotalCost1: '共',
  TotalCost2: '条費,',
  Updated1: '更新されました',
  Updated2: 'バー,',
  NotUpdated1: 'そして',
  NotUpdated2: 'バーは更新されていません。',
  NotMatchingTheCostOfTheProjectCanBeAdded: '一緻する費用項目がありません。新規追加可能',
  ChargeWasSuccessfullyUpdated: '料金の更新に成功しました。',
  NotMatchingTheCostOfTheProjectCanBeUpdated: '更新できる費用項目が一緻しません。',
  NoAddedCharge: '追加料金なし.',
  DefaultValuesAreSavedSuccessfully: 'デフォルト値の保存に成功しました。',
  ContSigned: '（契約済み）',
  ContUnsigned: '（未契約）',
  InvalidCont: '（契約の失効）',
  TheSystemHasBeenUpdatedPleaseRefreshThePage: 'システムが更新されました。ページを更新してください！',
  PleaseInputCosts: '費用項目を入力してください。',
  SelectTheSurchargeClause: '費用項目を入力してください。',
  HAWBCannotBeNull: 'AMSパーティション番号は空にできません！',
  ENSHblNbr2CannotBeNull: 'ENS NO cannot be empty',
  HAWBCannotBeRepeated: 'AMSパーティション番号は重複できません！',
  InlandCannotBeNull: '内陸ポイント/倉庫は空にできません！',
  rocordNumberCannotBeNull: 'カナダ税関届出番号は空にできません！',
  AreYouSureYouWantToDelete1: '本当に削除しますか',
  SureDeleteHbl: '註文削除後復旧できません、削除確認?',
  AreYouSureYouWantToDelete2: 'ですか？',
  PleaseSelectTheAMSNO: 'AMS番号を先に選択してください',
  TheMaximumCannotExceedLines: '最大5行まで！',
  DisplayColumn: 'カスタム表示列',
  Display: '可視',
  Name: '名前',
  TradeCommissionedUnitCannotBeEmpty: '取引-委託先は空にできません',
  TradeSalesSupportCannotBeEmpty: '取引-販売サポートは空にできません',
  TradingCurrencyCannotBeEmpty: '取引-注文通貨は空にできません',
  TradingExchangeRateCannotBeEmpty: '取引-注文為替レートは空にできません',
  TradeServiceFeeDiscountRateCannotBeEmpty: 'TradeServiceFeeDiscountRateCannotBeEmpty',
  TradeTheAmountOfWriteOffsCannotBeGreaterThanTheAmountOfOrders: '取引-受注消込金額は受注金額より大きくできません',
  TradePaymentNOCannotBeEmpty: '取引-送金番号は空にできません',
  TradePaymentNumberCannotBeGreaterThanBitsInLength: '取引-支払番号は16桁の長さを超えてはいけません',
  UnableToDeleteAllCharges: '料金はすべて削除できません。',
  PleaseCheckYourNetworkOrRefreshThePage: '親、あなたは今ネットワークのない異次元空間にいます！ネットワークが正常であるかどうかを確認するか、ページを更新してください。。',
  TheFileIsSentSuccessfully: 'ファイルの送信に成功しました。',
  PleaseSelectAFileToDownloadOrSend: 'ダウンロードまたは送信するファイルを選択してください。',
  PleaseSelectAFileSynchronization: '同期するファイルを選択してください。',
  PleaseSelectAFileCancelSynchronization: '同期を解除するファイルを選択してください。',
  FailedToModifyAFileType: 'ファイルタイプの変更に失敗しました。',
  PleaseSelectAFileType: 'ファイルタイプを選択してください.',
  MBLNOCannotBeDuplicated: 'MB/LNO2は重複できません！',
  PleaseSelectMBLNo: 'まずMBL番号を選択してください。',
  TotalWeightOfLadingAreInconsistent: '船荷証券の合計件の毛体が一致しない！',
  TOORDERIsUnavailableToRelease: 'TOORDERは放電できません',
  TheAssociatedPrimaryFormIsNotSelected: '関連マスタが選択されていません',
  PleaseSelectHBLNo: 'HBL番号を先に選択してください！',
  PleaseEnterTheBillOfLadingSerialNumber: '船荷証券の通し番号を先に入力してください！',
  PleaseUploadReleaseGuarantee: '有効な電源保存がありませんので、先にアップロードしてください',
  TheRecipientAddressCannotBeEmpty: '宛先アドレスは空にできません。',
  OperationIsNotReversible: '操作は可逆的ではありません。',
  Uncommitted: 'コミットされていません',
  Approved: 'レビュー済み',
  Submitted: '送信済み',
  Rejected: '却下されました',
  PleaseSelect: '選択してください',
  Uploaded: 'アップロード完了',
  Waiting: 'アップロード待ち',
  Uploading: 'アップロード中...',
  Other: 'その他',
  First: '最初のページ',
  Pre: '前のページ',
  Page: '第',
  AllPage1: '共',
  AllPage2: 'Page',
  Next: '次ページ',
  Last: '最後のページ',
  ShowFromTo1: '表示',
  ShowFromTo2: 'へ',
  AllRecord1: '共',
  Transactions: 'ペン',
  AllRecord2: 'Record',
  Convert: '換算',
  YouAreUnableToUseThisFunctionAsWHHasntBeenConfiguredIfNeedPleaseContactCSOnline: 'お客様、倉庫が設定されていないため、この機能を使用できません。ご希望の場合は、オンラインカスタマーサービスにお問い合わせください。',
  FirstSaveTheBusinessAutomaticLoadingIsInProgress: 'お客様、まず業務を保存して、自動配貨操作を行ってください。',
  FirstSaveTheBusinessAddSpecialGoods: 'お客様、業務を保存してから危険物を追加してください',
  GeneralTrade: '一般貿易',
  ProcessingWithSuppliedMaterial: '材料を加工する',
  ProcessingTrade: '供給は口に合う',
  SamplesOfAdvertisingProductsA: 'サンプル広告品A',
  Refuse: '拒否する',
  Agree: '同意',
  GoOn: '続行',
  SubmitAudit: 'スーパーバイザレビューの提出',
  DataValidation: 'データ検証中',
  DataValidatedWithWarning1: 'データの検証は完了しましたが、警告があります。続行します',
  DataValidatedWithWarning2: '【続行】をクリックし、キャンセルしてください',
  DataValidatedWithWarning3: '【キャンセル】をクリックしてください',
  DataValidatedSuccessfully1: 'データ検証成功、確認',
  DataValidatedSuccessfully2: '【確認】をクリックし、キャンセルしてください',
  DataValidatedSuccessfully3: '【キャンセル】をクリックしてください',
  DataValidatedFailure1: 'データの検証に失敗しました。検証に失敗したデータ項目を処理してから',
  DataValidatedFailure2: 'after validating again',
  WoChat: 'WoChat',
  TheSystemHasBeenUpdatedPleaseTurnTheModuleOnAgain: 'システムが更新されました。モジュールを閉じて再度開いてください。',
  TheSystemHasBeenUpdatedPleaseReLoginOrClearBrowserCache: 'システムが更新されました。再ログインするか、ブラウザキャッシュをクリアしてください。',
  AddAdjustment: '調整を追加する',
  AddCharge: '追加料金',
  AddCostCharge: 'Add cost Charge',
  AddPayCharge: 'Add pay Charge',
  EditAdjustment: '調整の修正',
  EditCharge: '料金の変更',
  EditCostCharge: 'Edit cost Charge',
  EditPayCharge: 'Edit pay Charge',
  DeleteAdjustment: '調整の削除',
  DeleteCostCharge: 'Delete Cost Charge',
  DeletePayCharge: 'Delete Pay Charge',
  DateOfAdjustmentCannotBeNull: '調整日は空にできません。',
  CurrencyOfAdjustmentCannotBeNull: '通貨は空にできません。',
  AmountCannotBeZero: '数量はゼロにできません。',
  UnitPriceCannotBeZero: '単価はゼロにできません。',
  AmountCannotBeZero2: '金額はゼロにできません。',
  ExchangeCannotBeZero2: '為替レートはゼロにできません。',
  RemarkTheLengthCannotExceed: 'コメントの長さは50を超えてはいけません',
  InvoiceNoCannotBeNull: '税金番号は空にできません。',
  InvoiceNoIsTooLong: '税金番号の長さが長すぎます。',
  PleaseAddSpecialGoodsFirst: '危険物を先に追加してください',
  UNNoIsEmpty: '国連番号を入力してください',
  LoadSpGoodsContainerError: '危険物梱包情報のロードエラー',
  AssociatedSpGoodsError: '危険物情報の関連付けエラー',
  NoAssociatedInfo: '関連情報がありません',
  InnerPackagingTypeIsRequired: 'パッケージタイプは必須',
  InnerPackagingQuantityIsRequired: '内包装件数は必ず記入してください',
  SeaPollutionOnlyEnterYN: '海洋汚染フィールドの値はYまたはNでなければなりません',
  SelectHsCode: 'HS番号を選択',
  SelectCargoChineseName: '中国語品名を選択します',
  DispatchNotYet: 'ディスパッチは成功していません。ディスパッチの変更は許可されていません',
  AllDataMustBeOperating: 'すべてのデータは正の操作状態でなければなりません',
  TheSelectedDocumentInconsistentNatureOfTheContainerLoadType: 'The selected document inconsistent nature of the container load type',
  TheNumberOfChargesLimited: 'チャージの最大数は超えられません',
  TheNumberOfSelectedDataLimited: '選択したデータは超えてはいけません',
  PleaseInputSearchCondition: 'クエリ条件を入力してください',
  PlaceOfDeliveryCannotBeNull: '配送先は空にできません',
  ImportSuccessChargesCount: '{count}件の費用のインポートに成功しました',
  CheckChargeDetailBranch: '操作中のデータが存在する支社は、現在の支社または1つ上の支社に属していません',
  ChangeSelectSales: '売上の変更を保存しますか？',
  NoSelectedCargoDocInformation: '船荷証券レコードを選択してください！',
  OverseaCostChargeEmpty: '売掛金が空です！',
  OverseasBillsCanNotBePrinted: '海外請求書は印刷できません（請求書が空、選択されていない、無効、権限なし）！',
  CheckHBLReleaseStateBeforePrint: 'ドロップ可能シートではないので印刷できません！',
  NoSelectedWarehouseInInformation: 'No selected warehouse in information!',
  NoWarehouseInInformation: 'No warehouse in information!',
  ConfirmTheShutOut: 'このチケットをキャンセルしますか？すべての費用が削除されます！',
  SaveSucceed: '保存に成功しました！',
  SelectOneJob: 'コピーを許可するのは1票のみです！',
  PleaseInputETD: '出発日の範囲を選択してください！',
  SelectJob: 'ビジネスを選択してください！',
  DateToday: '今日',
  PleaseSelectSoNo: 'オフ番号を選択してください',
  ChargeOffsetState: '費用はすでに赤で消費されているか、または赤で消費されています',
  isDeleteAllEDIContainer: 'すべての梱包情報を空にするかどうか',
  ServiceCodeCannotBeNull: 'サービスコードは空にできません',
  Choose: 'Choose',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeForceDel: 'この請求書は財務監査に提出されているため、強製的に削除することはできません。',
  ThisVerificationHasBeenDoneAndCannotBeForceDel: 'この注文はすでに適用されているので、強製的に削除することはできません。',
  ThisFormIsLockedAndCannotBeForceDel: 'このフォームはロックされているため、強製的に削除できません。',
  ConfirmTheForceDelOfTheBill: 'この請求書を強製的に削除しますか？',
  ForceDelSuccessfully: '強製削除に成功しました',
  IsNotOperationStatusCannotBeShutOut: '「操作中」状態の業務のみを一括してロールバックできます',
  IsNotOperationStatusCannotBeCancellation: '「正操作」状態の業務だけを一括廃棄できます',
  ManifestLink: 'マニフェストへのリンクは以下の通りです',
  ApplicationAmountCheck: '支払い申請金額が費用リストの合計金額と一緻しません。チェックしてください！',
  TipsOnSplittingExpenses: '分割チャージ金額は元のチャージ金額より大きくできません。分割チャージ金額を変更してください！',
  DcCopyCheck: 'このビジネスにはドキュメントがあります。部門または会社の情報がありません。ドキュメントを再選択してください！',
  CsrCopyCheck: 'この業務にはカスタマーサービスがありますが、部門や会社の情報がありません。カスタマーサービスを再選択してください！',
  SureDeleteThese: 'これを削除しますか？',
  OrdersOfBusiness: 'チケット業務ですか？',
  SureCancellationAndDeleteCharge: '廃止は確定ですか?すべての料金が削除されます!',
  SureShutOutAndDeleteCharge: 'このチケット業務を退関することが確定しますか?すべての料金が削除されます!',
  CheckingConsignation: 'この業務は委託できません。チェックしてから再試行してください！',
  TheSubBillHasBeenConsolidatedAndCannotBeDelete: 'このレシートはスペルチェック済みで、削除できません。',
  SaveFailedMessage: 'Saving failed. Please refresh and try again!',
  SettlementAgentCannotBeNull: '決済エージェントは空にできません！',
  SettlementAgentErrorPleaseReSelect: '決済エージェントエラー、再選択してください！',
  NowContainer: '現在のボックス',
  NowContainerCanNotDelete: '現在のボックスは使用中のため削除できません！',
  NotDelete: '削除できません！',
  PleaseSelectBoxType: 'ボックスタイプを選択してください！',
  PleaseEnterUnitPrice: '単価を入力してください！',
  PleaseSelectCurrency: '通貨を選択してください！',
  PleaseEnterTheStartDate: 'レンタル開始日を入力してください！',
  PleaseEnterThebuyDate: '購入日を入力してください！',
  PleaseEnterEndDate: '終了日を入力してください！',
  SuccessfulBoxAdjustment: 'ボックスの調整に成功しました！処理済み数量',
  NoBoxesProcessedSuccessfully: '箱の処理に成功しませんでした。実際の箱詰めを確認してください！',
  OnlyBuyCaseOrderBoxCanBeSold: '注文箱のみ販売できますので、ご確認ください！',
  ChoiceCaseSell: '同じ通貨の箱を選んで販売してください！',
  PleaseContainerData: 'Please enter box information!',
  UnifiedCurrency: '箱売りの注文は単通貨しかサポートしていないので、箱売りの通貨を統一してください！',
  PleaseCheckTheBoxToBeSold: '販売する箱をチェックしてください！',
  EditedFailMessage: 'Modification failed. Please refresh and try again!',
  DataValidatedWithPartialPass1: 'データの検証は完了しましたが、一部警告と失敗があります。続行します',
  DataValidatedWithPartialPass2: '【続行】をクリックし、キャンセルしてください',
  DataValidatedWithPartialPass3: '【キャンセル】をクリックしてください。注:検証に失敗した場合は、検証に失敗したデータ項目を処理してから',
  AddChangeCharge: '新規変更料金',
  ThereAreNoPayableBillsToPrint: '印刷できる支払可能なシートがありません。',
  ReleaseInformationNotSelected: '注文情報が選択されていません',
  AreYouSureYouWantTo: '本当に{0}にしますか？',
  NoRecordsAvailable: '{0}のレコードがありません。',
  NoDataToAudit: '監査できるデータがありません。',
  NoSplittingRecordSelected: '分割レコードが選択されていません。',
  NoDataToAudit2: '{0}できるデータがありません。',
  EditChangeCharge: '変更料金の変更',
  AddSpecialCharge: '特別料金の追加',
  EditSpecialCharge: '特別料金の改定',
  AddSpecialUpdate: '特別費用調整',
  Pstsftba: '調整が必要な特別料金を選択してください！',
  Nsecbe: '非特別料金は編集できません！',
  UpdateWarehouseRecord: '倉庫の変更を保存しますか？',
  CheckCostAndBusinessMismatching: '選択した費用項目がビジネスと一緻しません',
  TicketEntrustedCannotRepetitionDelegate: 'このチケットは既に委任されています。重複して委任しないでください！',
  NotFindCurrencyRatePleaseMaintain: '通貨{0}の為替レートが見つかりません。関連する為替レートをタイムリーに維持してから保存してください！',
  BillPaymentDeleteTips: '財務承認済および未消込処理状況でない支払要求のみを削除できます',
  SettlementAgentNotNull: '決済エージェントは空にできません！',
  PleaseSelectSameSettlementAgent: '同じ決済エージェントの請求書を選択してください！',
  TheHAWBAndMAWBAreInconsistentTheSystemWillModifyTheHAWBContinue: '新選小票目の港代理、貨物港、目的港、予約代理、航空会社、フライト、ETD、予約性質、マスタ運賃条件マスタと一緻しません。システムはレシートを修正します。続行しますか？',
  AMS_ReturnMessage: 'AMSスーツケースの毛体情報は実際と合わないので、調整してください！',
  AMS_ReturnMessageCanSave: 'AMSスーツケースの毛体情報は実際と一緻しません。保存を続けますか？',
  AMS_Quantity: '【AMS件数{0}{1}実件数{2}】',
  AMS_Weight: '【AMS総重量{0}{1}実総重量{2}】',
  AMS_Cubage: '【AMSボリューム{0}{1}実ボリューム{2}】',
  AMS_ContainerNo: 'コンテナ番号【{0}】:',
  CheckPortsByConsignation: '依頼した【{0}】は【{1}】港を維持していません。相手と確認してから依頼してください！',
  CheckPackingByConsignation: '依頼した【{0}】は【{1}】パッケージを維持していません。相手と確認してから依頼してください！',
  CheckCompanyByConsignation: '依頼した【{0}】には【{1}】のSCACコードなどの情報がありません。相手と確認してから依頼してください！',
  CheckCarrier: '【{0}】のSCACコードをメンテナンスしてから依頼してください！',
  SettleAccountMustBeSame: '決済対象は同じでなければなりません',
  ReceivableCannotMorethanPay: '売掛金は買掛金より大きくすることはできません',
  PleaseSelectJobs: 'ビジネスシートレコードを選択してください',
  SapCommitCheck: 'SAP一回の提出が完了しました。重複して提出しないでください',
  SapCancelCommitCheck: '費用はSAP処理状況を取り下げることができません。費用のSAP処理状況を確認してください',
  escnm: '経費精算部門はメンテナンスされていません',
  SapSynchronizationSuccess: 'SAP同期料金成功',
  SapSynchronizationFault: 'SAP同期料金に失敗しました',
  SapStatusCanNotAudit: '費用はSAP処理状況を監査できません。費用のSAP処理状況を確認してください',
  ChangeOrderSubmissionFailed: '変更の送信に失敗しました。変更が必要な料金が検出されませんでした！',
  SureYouWantToDeleteFilesTwo: 'Are you sure you want to batch delete these {0} files?',
  JumpFailed: 'ジャンプに失敗しました',
  SelectCopyContent: 'コピーするコンテンツを選択します',
  CopyContent: '内容をコピーします',
  SelectImportContent: '導入内容を選択します',
  ImportContent: 'コンテンツを導入します',
  DifferenceOverwritesTheOriginalValue: '差異フィールドは元の値を上書きします',
  DifferenceRetainsTheOriginalValue: '差分フィールドは元のままです',
  RememberToChoose: '私の選択を覚えています',
  TheImportedServiceNumberDoesNotExistProcedure: '導入された事業番号は存在しません',
  TheIDOfTheImportedServiceMustBeDifferentFromThatOfTheImportedService: '導入する事業番号と導入される事業番号は同じではいけません。',
  CopyNumber: '今回のコピー数',
  QuickSearchBusinessNo: 'クイック検索:業務番号',
  QuickSearchChineseName: 'ショートカット検索：中国語名',
  FinancialDateOfASingleExpense: '個別費用の会計処理日を変更しますか？',
  ExpenseFinancialDateModifiedSuccessfully: '経費会計処理日の変更に成功しました',
  ModifyTheFinancialDate: '会計処理日を変更しますか？',
  FinancialDateModifiedSuccessfully: '会計処理日の変更が成功しました',
  ApprovalDateIsEarlierThanBusinessDate: 'レビュー日はビジネス日より小さいです。続行しますか？',
  AreYouSureToReviewTheseLists: 'これらのリストを確認しますか？',
  ThisBusinessIsNotApproved: 'このビジネスは【{0}】状態ではありません。監査は許可されていません。確認してください！',
  ThisBusinessIsNotApproved2: 'このビジネスは【{0}】状態ではありません。取り下げは許可されていません。確認してください！',
  TheDocumentChangeSubmission: '本当に変更の提出を取り消しますか？',
  AllowOrderChange: '本当に変更を許可しますか？',
  AllowToChangeTheOrderSuccessfully: '変更の成功を許可します',
  NoExpenseSelectedOrNotInApprovalStatus: '費用が選択されていないか、監査状態ではありません',
  ExpenseStatusUpdatedSuccessfully: '費用処理状況の更新が成功しました',
  BusinessHasGeneratedVouchers: 'ビジネスが買掛伝票を生成しました。',
  UnableCancelAudit: '監査をキャンセルできません。',
  BusinessNumberWithGeneratedVouchers: '生成された証憑を含む業務番号:',
  AreYouSureYouWantToCancelTheApproval: '本当に監査をキャンセルしますか？',
  LCLTicketsCannotBeReviewedSeparately: '箱のレシートは単独では審査できません。メインチケットを審査してください。',
  ItIsLocked: 'ロックされているため印刷できません。ロックを解除するには上司に連絡してください！',
  PleaseSelectTheBusiness: '取引日を変更するビジネスを選択してください',
  BusinessDateModifiedSuccessfully: '取引日付の変更に成功しました',
  BatchApprovalFailed: '一括承認に失敗しました',
  PleaseSelectTheBusinessToPrint: '印刷するビジネスを選択してください',
  NoInTheSelectedData: '選択されたデータの中に【{0}】状態ではない業務があります。審査は許可されていません。チェックしてください！',
  TheApprovalDateIsEarlierThanTheBusinessDate: 'レビュー日はビジネス日より小さいです。続行しますか？',
  FailedToGetDetails: '詳細の取得に失敗しました',
  PleaseEnterTheBoxSealNumber: '箱の封号を入力した後、利益分析表を印刷してください。',
  AfterPrintingTheProfitAnalysisStatement: '利益分析表を印刷した後、この業務は財務審査に提出され、変更できません。続行するかどうか？',
  PleaseEnterTheApprovalDate: 'レビュー日を入力してください',
  PleaseSelectARecordToView: '表示するレコードを選択してください',
  ContractExpireCannotCreated: 'この委託先の契約が期限切れになり、業務を作成できなくなりました',
  CheckBusinessStatus: '操作に失敗しました。ビジネスに対応する状態が正常であるかどうかを確認してください。',
  CheckCustomsSaved: '通関資料をアップロードする前に、通関申告書の情報を保存してください！',
  SelectCustomsBroker: '通関行を選択してください。',
  SelectCustomsBrokerPlatFormProvider: 'パートナーにいません。現在選択されている通関行にプラットフォームプロバイダが設定されています。送信できません。',
  SelectCustomsSonoLobFiles: '通関単番号",通関行,通関資料,業務タイプは空にできません。データをチェックしてください',
  VesselAndvVoyageFlightisEmpty: '船名航次は空です。送信を確定しますか？',
  customsInfoIsAlredySend: 'この通関申告書はすでに送信されており、一度送信することを一時的にサポートしています。修正が必要な場合は、オフラインで対応する通関業者に連絡してください',
  DocumentEditedTips: 'このチケットのチケットではないので、編集できません。',
  NotGroupBusinessesCannotBeEdit: '同班業務でなければ編集に入ってはいけません',
  CustomerTipMessage: '【{0}】は委任先ではありません。再選択してください！',
  PortOfLoadingPortCannotBeNull: 'ロードポートは空にできません',
  PromissoryNoteIsAFormalBusiness: '約束手形はすでに正式業務です！',
  CannotBeConvertedToFormalBusinessInBatch: '業務の出所が「テナント内の自身の業務」である情報が含まれており、正式業務への一括処理ができません。',
  whetherToTransferSmallTicketToFormalBusinessAtTheSameTime: 'チケットを同時に正式業務に転送しますか？',
  transferSmallTicketToFormalJobAtTheSameTime: 'チケットは同時に正式業務に移行します',
  onlyTheMasterTicketIsTransferredToFormalJob: 'メインチケットのみが正式業務に転送されます',
  pleaseTransferTheCorrespondingMasterTicketToFormalJobFirst: 'まず対応するマスタチケットを正式業務に回してください！',
  BusinessCannotBeOperatedTogether: '通常業務と委託業務は一緒に操作できません。再選択してください！',
  PleaseEnterTheWarehouseNumber: 'クイック検索:倉庫番号',
  BookingSeal: '予約シール',
  CheckSplitCharges: '費用が分割されました。分割費用を削除してください',
  mutualChargeSynchronizationSuccess: '相互委託手数料の同期が成功しました！',
  mutualChargeSynchronizationFault: '相互委託料金の同期に失敗しました！',
  confirmQuit: '本当に終了しますか？',
  SelectMBL: '船荷証券番号（予約ラベル-MB/LNO）は空にできません',
  SelectMBLSI: '主番号（輸入操作-主番号）は空にできません',
  SelectMBLAE: '主番号（基本-主番号）は空にできません',
  SelectMBLAI: 'マスター番号（空輸操作-マスター番号）は空にできません',
  SelectLob: '取引タイプ を選択してください.',
  SelectPreCustomsDate: '通関日を選択してください。',
  SelectHarborDistrictSe: '港区（予約タブ-港区）は空にできません',
  SelectHarborDistrictSi: '港区（輸入操作-港区）は空にできません',
  DestinationPlaceNotNull: '納品先（輸入作業-納品先）は空にできません！',
  AirportPortNotNull: '空港ポートは空にできません',
  ExpectedDateOfArrivalNotNull: '予定到着日（輸入操作-到着日）は空にできません！',
  SelectCustomsFiles: '通関資料を選択してください。',
  CustomsHasBeanSend: 'この通関申告書はすでに送信されており、一時的に一度送信することをサポートしています。修正する必要がある場合は、対応する通関業者に連絡してください',
  FileSizeExceeds4MBYouCannotUploadPleaseSendEmailSe: '個々のファイルは20Mを超えることはできません。xh08@thecustoms.com.cnメールボックスにメールで送信してください',
  PleaseUploadFileSeaExport: '通関依頼書、配船情報、輸出通関申告書の草書及び商品申告要素、領収書、ボックスリストなどの書類をアップロードしてください。',
  PleaseUploadFileSeaImport: '通関依頼書、船荷証券、船荷証券情報またはコピー、領収書、箱書、契約書、産地証明書、商品申告要素などの書類をアップロードしてください。',
  PleaseUploadFileAirExport: '通関依頼書、船荷証券、輸出通関申告書などの書類をアップロードしてください。',
  PleaseUploadFileAirImport: '通関依頼書、到着通知書、空輸船荷証券、領収書、ボックスリスト、契約書、産地証明書、商品申告要素などの書類をアップロードしてください。',
  SuccessfulCustoms: '通関成功！',
  FaildCustoms: '通関要求に失敗しました。管理者に連絡してください！',
  AsyncReceivableChargesToImportJob: 'すべての売掛金が輸入業務に同期されます。続行しますか？',
  AsyncPayableChargesToImportJob: 'すべての買掛金が輸入業務に同期されます。続行しますか？',
  escnm2: '経費精算部門は空にできません。',
  SelectMoreTwoRow: '結合するデータを少なくとも2つ選択してください！',
  OnlySplitMasterJob: 'メインチケットのみ分割できます！',
  SplitJobTip: 'BuyerConsoleFCLタイプのマスタチケットを選択し、業務状態が操作中のマスタチケットを分割してください！',
  CombinationJobSelectMasterTip: '次の業務を組み合わせますか？一票の業務員を主票として選択してください。',
  CombinationJobForFcl: '統合タイプはフルボックスとBuyerConsoleFCL',
  CombinationJobForJobState: 'ビジネス状態は正の操作状態',
  CombinationJobForCustomer: '委託先が一緻',
  CombinationJobForVessel: '船名一緻',
  CombinationJobForVesselVoyage: '航海一緻',
  CombinationJobForMaster: 'マスタを選択してください！',
  CombinationJobTip: '{0}の業務を選択して操作してください！',
  ValidateCombinationJobTip: '伝票番号{0}の業務はすでに使用されています。キャンセルボタンをクリックして、組み合わせ操作をやり直してください！',
  OnlyJoinForCombinationJob: '箱詰めタイプとBuyerConsoleFCLの業務のみが許可されます！',
  TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue: '請求先が一緻しません。続行しますか？',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue2: '新規チケットの船名、フライト、輸送業者、予約代理店、目的港代理店、ETD、ETA、倉庫情報、船会社の予約番号はメインチケットと一緻しません。システムはレシートを修正します。続行しますか？',
  HblNoMoreThanTwelve: '分数は12桁を超えてはいけません！',
  WriteOffPushSuccess: '消込レコードのプッシュが成功しました！',
  WriteOffPushError: 'レコードプッシュの適用に失敗しました！',
  CancelConfirmBill: 'キャンセル料金の確認状態を同期しますか？',
  AreYouSureYouWantToDeleteTheSelectedFee: '選択した料金の削除を確認しますか？',
  JobOfClosingAccountTip: '業務日は保存できません。調整して保存してください！',
  ThePacketHasBeenSentAndWhetherToImportItAgain: 'メッセージを送信しましたが、再度インポートしますか？',
  PleaseCheckAtLeastOnePieceOfData: '少なくとも1つのデータを選択してください',
  NoHasViewRole: '表示権限がありません。管理者に連絡して構成してください！',
  NoHasViewBillingRole: '請求書を表示する権限がありません。管理者に連絡して設定してください！',
  NoHasViewBillingGroupRole: '取引明細書を表示する権限がありません。管理者に連絡して設定してください！',
  checkSpecialChargeTips: '売上記録に特別費用が含まれている場合は、買掛伝票を生成できません。再選択してください！',
  CheckCustomJobTypeTips: '保存する前にカスタム取引タイプ を選択してください！',
  AMSCodeCannotBeNull: '基本構成AMSCompanyCodeは空にできません！',
  MblNoIsOverLength: '【MB/LNO】フィールドが16ビットを超えています。',
  AmsNoIsOverLength: '【AMSNO】フィールドは12ビットを超えています。',
  IsOverLengthTip: '{0} characters are too long, please do not exceed {1} characters per line of data.',
  UnitTypeNotNull: 'Unit Typeを空にすることはできません。',
  Shipper: '差出人',
  Consignee: '荷受人',
  Notify: 'NOTIFY',
  SecondNotify: '二番目の通知先',
  SpecialCharacter: '{0}フィールドに不正な文字が含まれているため、保存できません！',
  TipsOnAutoSplittingCharge: '分割料金の税込み価格を入力してください！',
  DeleteSmallTicketTips: 'チケットを削除する権限がありません！',
  SyncToSmallTicketSuccessTips: '{0}ノードの状態がチケットに同期されました！',
  OperationTypeInUsed: '{0}{1}デフォルトで表示されている{2}運送条件があります。再選択してください！',
  StartUpdatingTheBasicData: '基礎データの更新開始',
  BasicDataUpdateSuccessfully: '基礎データの更新が成功しました',
  BatchSubmitCheck: '操作中または事前に提出されたリストのみを一括して提出できます！',
  isExistHBLANDMBLTips: '1つのメイン番号の下のサブ番号は重複できません。サブ番号を再入力してください！',
  operateTypeUpdateTips: '操作モード変更、MAWB送受信情報を更新するかどうか',
  SettlingAgentInconsistent: '決済エージェントが一緻しません。続行しますか？',
  SettlingAgentInvoiceTitleInconsistent: '決済エージェントと請求先が一緻しません。続行しますか？',
  ChargeEmpty: 'チャージが空です！',
  NoChargeForTheSettlementOfPrint: '印刷条件に一緻する料金決済対象がありません。',
  PleaseEnterTheCreationDate: '作成日を入力してください。',
  SelectDate: '日付を選択',
  DefaultCurrency: 'デフォルト通貨',
  EDISUBMISSIONCenter: 'EDI送信センター',
  EDICenter: 'EDIセンター',
  MessagePreview: 'メッセージプレビュー',
  MessageDesign: 'メッセージデザイン',
  ReceiverCodeCannotBeEmpty: '受信者コードは空にできません',
  SelectEDIType: 'EDIタイプの選択',
  NotConfigured: '未構成',
  SelectSendingChannel: '送信チャネルの選択',
  SelectFileNature: 'ファイルのプロパティを選択',
  SelectFileTemplate: 'ファイルテンプレートの選択',
  SelectedBusiness: '選択されたビジネス:',
  BackToEDICenter: 'EDIセンターに戻る',
  Design: 'デザイン',
  SendAll: 'すべて送信',
  Tips: 'ヒント:',
  UsedInTemplateDesign: 'テンプレートデザインで使用',
  Check: '検証を行う',
  SentSuccessfully: '送信に成功しました！！',
  TemplateSavedSuccessfully: 'テンプレートの保存に成功しました',
  OtherDocuments: 'その他のファイル',
  ClickUpload: 'クリックしてアップロード',
  UnsupportedFileType: 'サポートされていないファイルタイプ',
  TheSizeExceedsTheLimit: 'ファイルサイズが製限を超えています',
  UploadFailed2: 'アップロードに失敗しました',
  PleaseSelectABusinessNumber: 'ビジネス番号を選択してください',
  TheExceeds20MBAndUploaded: '1ファイルのサイズが20MBを超えるため、アップロードできません。',
  UploadPleaseContactTheAdministrator: 'アップロードに失敗しました。管理者に連絡してください。',
  FailedPleaseRefreshAndAgain: 'データの取得に失敗しました。更新してからやり直してください',
  ExternalImportedDataNonEditable: '外部インポートデータ、編集不可',
  ExternalDataCannotBeDeleted: '外部インポートデータ、削除できません。',
  RequestSucceededExporting: '要求は成功しました。エクスポートしています！',
  Main: 'メイン',
  PleaseEnterTheWarehousingNumber: '倉庫番号を入力してください！',
  PleaseEnterTheWarehouseName: '倉庫名を入力してください！',
  PleaseEnterTheWarehouseInDate: '入庫時間を選択してください！',
  PleaseMaintainWeighDetail: 'まず重量（実際の）貨物の明細を維持してください！',
  PleaseEnterComments: '承認結菓が不合格です。処理意見を記入してください！',
  PleaseSelectTheClosingWeight: '閉じる重量を選択してください！',
  SureToSaveLabeling: 'まだ計量されていません。ラベル情報を保存するかどうかを確認してください。',
  PleaseLengthWidthPieces: '正しい形式のサイズを入力してください:縦*横*高さ*件数！',
  PleaseTheNumberOfPieces: '件数を入力してください！',
  WarehouseNumberAlreadyExistsContinue: '倉庫番号はすでに存在します。続行しますか',
  SavedSuccessfully: '保存に成功しました！',
  ChecklistSuccessfully: '承認処理状況の更新に成功しました！',
  NoSynchronizationContent: '同期するコンテンツがありません',
  ThereSynchronizationSpecialGoodsSynchronize: '箱詰め情報に特殊貨物に関連付けられた箱があり、同期後に特殊貨物を再関連付けする必要があります。同期を確認しますか？',
  SynchronizationSucceeded: '同期が成功しました',
  SynchronizationFail: '同期に失敗しました',
  ThisJobIsNotWorkingCanNotBeEdited2: '指定されたビジネスは正の操作状態ではなく、同期を実行できません',
  ASameBoxTypeExists: '同じボックスタイプのレコードがすでに存在します！',
  IfToRefreshTheContainers: '箱の量が変更されました。元の箱単位の料金を更新しますか？',
  BusinessCannotBeEmpty: 'ビジネスは空にできません！',
  ViewChargebackFile: 'キャンセルファイルの表示',
  SelectDepartment: '部門の選択',
  PleaseSelectADepartment: '部門を選択してください！',
  ReceiptSucceeded: '入荷が成功しました',
  ReceiptError: '入荷エラー',
  SubmittedForDeletion: '添削が送信されました',
  ModificationFailed: '変更に失敗しました',
  EDIStatusChangeRecord: 'EDI処理状況変更レコード',
  FeedbackNode: 'フィードバックノード',
  YouTheLinkAddressDirectly: 'リンクアドレスを直接コピーすればペアリングできます',
  HistoricalAnomaly: '履歴異常',
  TimeOfOccurrence: '発生時間',
  VerificationOfEstimatedProfitMargin: '予測利益率の検証',
  EstimatedIncome: '予想収入',
  EquivalentToRMB: '人民元に換算する',
  EstimatedCost: '推定コスト',
  EstimatedProfit: '予想利益:',
  EstimatedProfitMargin: '予想利益率:',
  EstimatedRemarks: '予測コメント:',
  EstimatedMustBeFilledIn: '見積コメントは必ず記入してください。',
  Sunday: '日曜日',
  Monday: '月曜日',
  Tuesday: '火曜日',
  Wednesday: '水曜日',
  Thursday: '木曜日',
  Friday: '金曜日',
  Saturday: '土曜日',
  SelectFileType: 'ファイルタイプの選択',
  FileInformation: 'ファイル情報',
  Thumbnail: 'サムネイル',
  DownloadPhotos: '写真をダウンロードする',
  UploadComplete: 'アップロード完了',
  UploadFailedSigh: 'アップロードに失敗しました！',
  HelloNNPleaseCheck: 'こんにちは、ご査収ください',
  WarehousingNo: '倉庫番号-',
  WarehousingNoColon: '倉庫番号:',
  PhotosNthankYouN: 'の写真ありがとう',
  SendingSucceeded: '送信に成功しました！',
  SendingFailed: '送信に失敗しました！',
  PleaseTheFileToDownload: 'ダウンロードするファイルを選択してください。',
  WaybillNo: '運送状番号:',
  ConfirmSending: '送信を確定します',
  ReturnToModify: '変更を返します',
  ChannelName: 'チャネル名',
  PleaseSelectASendingChannel: '送信チャネルを選択してください！',
  FailedToGetTemplate: 'テンプレートの取得に失敗しました',
  TheDocumentOfTheContinue: '新しく選択されたレシートの船名、船便、船会社、メインリスト番号、交換代理店、出航日、到着予定日、実際の到着日、倉庫、メインリストの出荷方法とメインリストの運賃条項がメインリストと一緻しないか、レシートの税関のサブリスト番号が空です。システムはレシートを修正します。続行しますか？',
  PleaseSelectACodingRule: 'コーディング規則を選択してください.',
  ApplicationForRelease: 'カプセルのリリースを申請します',
  ApplyForShipperCode: '申請SHIPPERCODE',
  NoDataSelected: 'データが選択されていません！',
  InvalidFee: '料金が無効です！',
  ReceivingMethod: '受信メソッド:',
  CellPhoneNumber: '携帯電話番号:',
  NoteDoesNotAffectPartner: '注:このページで変更された情報は、パートナーの元の構成に影響しません',
  emptySopNodeWarning: 'プッシュ ノードが空の場合、メッセージは正しくプッシュされません。',
  AsynchronousLocking: 'バックグラウンドで非同期ロックが行われています。後で右上の（メッセージ）に行って結菓を確認できます',
  AsynchronousJobAccountVerify: 'バックグラウンドで非同期処理が行われています。後で右上（メッセージ）に行って結菓を確認してください',
  RepeatClick: 'バックグラウンドでロック操作を実行しています。繰り返しクリックしないでください',
  RepeatClickJobAccountVerify: 'バックグラウンドでレビューを実行しています。繰り返しクリックしないでください',
  RepeatClickJobAccountVerify2: 'バックグラウンドでキャンセル操作が実行されています。繰り返しクリックしないでください',
  AddFromPartner: 'パートナーから追加',
  AddManually: '手動で追加します',
  ReceivingMode: '受信モード',
  PushNodeCannotBeEmpty: 'プッシュノードは空にできません！',
  PushBeEmptyPleaseCheck: 'プッシュノードは空にできません。確認してください:',
  DetailedNumberOfCheckedGoods: 'チェックした商品の明細件数',
  NumberAssociatedPackingInformationPieces: '関連する梱包情報件数',
  DetailedWeightOfGoodsChecked: 'チェックした貨物の明細重量',
  AssociatedPackingInformationWeight: '関連する梱包情報の重量',
  DetailedVolumeOfGoodsChecked: 'チェックされた貨物の詳細体積',
  AssociatedPackingInformationVolume: '関連するパッキング情報ボリューム',
  CopyShippingMarkAndName: '委託マークの品名からの抄録',
  OperationCategory: '操作カテゴリ',
  PleaseEnterTheBusinessNumber: 'ビジネス番号を入力してください。',
  NonExistent: '存在しません.',
  ContainerTip: 'このボックスは費用に関連付けられています。関連付けを解除してからボックス番号を変更してください',
  UploadCustomsDeclarationFile: '通関ファイルのアップロード',
  UploadChargebackFile: 'キャンセルファイルのアップロード',
  RevenueTypeCannotBeBlank: '【収支タイプ】は空にできません！',
  SettlementCompanyCannotBeBlank: '【決済単位】は空にできません！',
  IncorrectFormatOnlyIntegerSupported: '税率データのフォーマットが正しくなく、整数のみがサポートされています！',
  domesticForeignCannotBeEmpty: '【国内海外】は空にできません！',
  ImportResults: 'インポート結菓',
  AllSuccess: 'すべて成功',
  AllFailed: 'すべて失敗しました',
  PartialFailurePartialSuccess: '部分的に失敗、部分的に成功',
  OddNumbers: '単番',
  PleaseTheSameBusinessOperate: '同じ取引タイプ のビジネスを選択して操作してください！',
  OperationError: '操作が間違っていました',
  NewBusiness: '新規ビジネス',
  ThePleaseRefreshAndAgain: 'システムがビジーです。更新して再試行してください',
  SubmittersRemarks: '提出者のコメント',
  PleaseFillInTheRemarks: 'コメントを記入してください',
  YouAreNotTheSubmitter: '提出者の上司でないと、この業務を操作できません！',
  PleaseFillInTheRemarksSigh: '備考情報を記入してください！',
  PleaseEnterRemarks: '備考情報を入力してください！',
  TheTheCurrentOperationMaintenance: '現在の操作は上級管理者を維持していません。維持してから本業務を提出してください！',
  FailedForApprovalPleaseAgain: 'スーパーバイザレビューの送信に失敗しました。更新して再試行してください！',
  SubmittedSupervisorForApprovalSuccessfully: 'スーパーバイザ承認の送信に成功しました',
  ApprovedPass: '承認済み！',
  ApprovalRejected: 'レビューは拒否されました！',
  Problem: '問題',
  Synchronized: '同期されました',
  NotSynchronized: '同期されていません',
  YouToEditTheAdministrator: 'データを編集する権限がありません。管理者に連絡してください',
  SentOut: '送信済み！',
  DefaultPSettlementID: 'デフォルトの固定決済オブジェクトID',
  IsAREmpty: 'デフォルト受取人が空かどうか',
  IsAPEmpty: 'デフォルトの対応オブジェクトが空かどうか',
  TheFormCannotBeEmpty: '申告書は空にできません！',
  ReminderOfTheCustomsData: '注意:通関資料をアップロードする前に、「確定」をクリックして通関申告書の必須情報を保存してください',
  ReminderOfTheCustomsPrint: '注意：次のデータは通関明細にはプッシュされず、文書データソースの印刷にのみ使用されます',
  ObtainActualBusinessData: '業務の実際を取る.',
  TheToBeViewedAnyone: 'ファイルは誰にも表示またはダウンロードできません。',
  YouPermissionToViewDownload: '表示またはダウンロードする権限がありません',
  File: 'ファイル',
  PleaseInTheSubmissionNotes: '送信コメントを入力してください',
  ContainsInvoicesThatCannotBeModified: '変更できない請求書が含まれています',
  RemarksReviewedBy: 'レビュー担当者のコメント',
  numberingRuleCannotBeEmpty: '【採番規則】は空にできません！',
  PortAreaDataComparison: '港区データ比較',
  ImportMode: 'インポートモード',
  Keep: 'キープ',
  Explain: '説明:',
  BlackIsTheInputData: '黒は入力データ、',
  BlueThePortAreaData: '青は港区データ,',
  GrayIsPreEnteredData: 'グレーは事前に入力されたデータ',
  UpdatedToPortAreaData: '港区データに更新',
  lclCompareHarbourTips1: '1. The default is all overwritten ("port data" all covers "system entry" data), unchecked box means that system data is retained, and port data is not covered; Uncheck all to keep the original system data',
  lclCompareHarbourTips2: '2.Red indicates information that compares "system data" with "port data"',
  lclCompareHarbourTips3: 'Please confirm the correct packing information as soon as possible, it will affect the subsequent SOP and container warning information push display',
  UpdatedData: 'Updated data',
  compareHarbourTips1: '1. Default full coverage (all data in the port area covers data entered by the system)',
  compareHarbourTips2: '2. Click the box number to switch to view the information, and the red color indicates the information that is inconsistent with the "system data" and "port data"',
  compareHarbourTips3: '3.If unchecked in \'Other\', \'System Data\' will be removed from the packing information, and \'Port Area Data\' will not add packing information; If unchecked in the corresponding box number, the \'system data\' will be retained; Uncheck all options to retain the original system data',
  compareHarbourTips4: 'Please confirm the correct packing information as soon as possible, as it will affect the subsequent SOP and push display of box cargo warning information',
  SystemEntry: 'システム入力',
  PortAreaData: '港区データ',
  ImportDescriptions: 'インポートタイプは修正で、システムはそれぞれ箱番号、箱型、箱の種類によって港区と一緻するデータにマッチングします。インポートタイプは新規、港区データと一緻するデータが見つかりません。インポートタイプは保持で、入力したデータが港区のデータに一緻しない場合は、元の入力データになります。',
  WhenTheBoxIsIdentifiedAsABox: '箱物識別子が箱の場合,伝票番号は表示されず,毛体のデータは荷物の合計となる.',
  ClickEnteredDataPleaseOperation: '【港区データに更新】をクリックすると、システムは選択した情報に基づいてシステム入力データを港区データに更新し、フォントの色が黒に変わります。港区データが間違っていないことを確認してから操作してください。',
  Determine: '確定',
  Cancel2: 'キャンセル',
  PleaseAtLeastOneRecord: '少なくとも1つのレコードを選択してください！',
  Hello: 'こんにちは',
  EnclosedPleaseFind: 'ご査収ください',
  PhotosOf: 'の写真',
  ThankYou: 'ありがとう',
  TheAndFreightTermsBlank: '新しく選択したレシートの船名、船便、船会社、メインリスト番号、交換代理店、出航日、到着予定日、実際の到着日、倉庫、メインリストの出荷方法とメインリストの運賃条項がメインリストと一緻しないか、またはレシートの税関のサブリスト番号が空です。',
  TheModifyTheSmallContinue: 'システムはレシートを修正します。続行しますか？',
  SaveFailedSigh: '保存に失敗しました！',
  CellPhoneNumber2: '携帯電話番号',
  NoSopNodeMatched: '現在のビジネスのノードが一致しません。再度選択してください',
  NameCannotBeEmpty: '名前は空にできません！',
  PleaseSelectARecord2: 'レコードを選択してください。',
  ChangePassword: 'パスワードの変更',
  OriginalPassword: '元のパスワード',
  NewPassword: '新しいパスワード',
  ConfirmPassword: 'パスワードの確認',
  ModificationPleaseLogInAgain: '変更に成功しました。再ログインしてください',
  TheEnteredTwiceAreInconsistent: '2回入力されたパスワードが一緻しません',
  DearUser: '親愛なるユーザー:',
  ItSystemInOrderMode: '現在のブラウザモードが互換モードであることを検出すると、CargoWareシステムの実行速度に影響を与えます。システムの実行速度と操作効率を向上させるために、極速モードに切り替えてください。',
  TheShownInTheBelow: '具体的な操作は次の図のようになります:',
  ToSwitchTutorialsSee: '切り替えチュートリアルはこちら:',
  GotIt: 'わかりました',
  FullScreen: 'フルスクリーン',
  EarlyWarningReminder: 'アラート通知',
  AnnouncementMessage: 'お知らせメッセージ',
  Cancellation: 'ログアウト',
  FlagshipEdition: 'フラッグシップエディション',
  BasicEdition: '基本版',
  TrialCustomers: '試用顧客',
  FormalCustomer: '正式顧客',
  SystemAdministrator: 'システム管理者',
  RefreshCacheMethod: 'キャッシュのリフレッシュ方法',
  AfterTheCorrespondingCacheData: '基礎資料のメンテナンスが終わったら、対応するキャッシュを更新して最新のデータを取得してください。',
  ViewCacheRefreshMethod: 'キャッシュのリフレッシュ方法を表示する',
  PleaseExitTheEditingModule: '変更したデータを保存するか、編集状態を終了してからモジュールを閉じてください。',
  SessionPleaseLogInAgain: 'セッションがタイムアウトしました。再ログインしてください',
  EDITemplateExceptionDownloadFailed: 'ediテンプレートが異常で、ダウンロードに失敗しました...',
  One: '一',
  Two: '二',
  Three: '3',
  Four: '4',
  Five: '5',
  Six: '六',
  Just: 'ちょうど',
  MinutesAgo: '分前',
  HoursAgo: '時間前',
  OneDayAgo: '1日前',
  LastWeek: '最近1週間',
  LastMonth: '最近1ヶ月',
  LastThreeMonths: '最近3ヶ月',
  PleaseSelectDataFirst: '最初にデータを選択してください',
  SelfBooking: '自分で予約します',
  CommissionedBooking: '予約を依頼する',
  CustomerSelfBooking: 'お客様が予約したクラス',
  OwnContractPrice: '自己契約価格',
  CustomerOffer: 'お客様の見積もり価格',
  OverseasAgentContractPrice: '海外代理契約価格',
  UncommittedPrice: '予約なし',
  BuyerLCL: 'BUYERの箱詰め',
  InnerPacking: 'コンテナ、',
  DoorPointPacking: 'ドアポイント梱包、',
  SelfPullingAndSelfSending: '自拉自送,',
  DeclareAtCustoms: '通関、',
  Fumigation: '燻蒸,',
  CommodityInspection: '商品検査、',
  BookingSpace: '予約クラス,',
  SetSpell: '集合スペル',
  PersonalBelongings: '私物',
  OneMasterAndManyPoints: '一主多点',
  OneMasterAndOneMinute: '一主一分',
  UnknownType: 'タイプ不明',
  Marked: 'マークされています',
  Unmark: 'マークなし',
  PendingOrder: '注文待ち',
  OrderPlaced: '注文しました',
  ReceivedOrder: '受注しました',
  NotIssued: '未発行',
  Issued: '発行済み',
  Retrieved: '取り込み済み',
  Accepted: '受信しました',
  Claimed: '受け取りました',
  ChangeOrder: '変更中',
  ApprovedBusinessCannotBeEdited: '監査されたビジネスは編集できません。',
  OrderAlreadyApproved: '注文{0}は承認済みです。',
  YouPermissionToEditNotes: 'チケットを編集する権限がありません。',
  EnglishNameOfHBLConsignee: 'HBL荷受人の英語名',
  EnglishNameOfHBLShipper: 'HBL積荷の英語名',
  AgentNetworkCustomerService: 'エージェントネットワークサービス',
  ReImportAfterModification: '修正してから再インポート可能',
  DownloadFailedData: 'ダウンロードに失敗したデータ',
  TheCaseOfMultipleFirst: '期限延長は複数選択での使用はお勧めしません。余分なチェックが入っていないかチェックしてください！',
  InvalidNumberEntered: '入力された数値が無効です！',
  TheOrThePartnerSigned: 'お客様が署名したか、パートナーが署名されました！',
  FirstDateCannotBeBlank: '最初の接触日は空にできません！',
  PleaseInTheTelephoneNumber: '電話番号を入力してください！',
  PleaseRemoveTheTicketFirst: '先にチケットを削除してください',
  ExpenseHasBeenEntered: '費用が入力されました',
  ConsolidationHasBeenDone: '連結を実行しました',
  Save: '保存しますか？',
  PleaseEnterCurrencyExchangeRate: '通貨レートを入力してください',
  FailedOpenSalesQueryDetails: '販売クエリの詳細を開くことができませんでした！',
  pleaseEnterTemplateName: 'テンプレート名を入力してください',
  blank: '空白',
  PartnersBeenAddedToBlacklist: 'パートナーがブラックリストに追加されました！',
  ThisCustomerRiskyCustomerOperateOrdersWithCaution: 'このお客様はリスクのお客様です註文の{0}にはご注意ください',
  AlreadyExistsOverwriteOriginalScheme: 'スキーム名はすでに存在します。上書きしますか？',
  NoDataToSave: '保存するデータがありません',
  ColumnSettings: 'カラム設定',
  CurrentPage: '現在のページ',
  CurrentSelection: '現在の選択',
  NoModificationAllowedAfterBusinessSubmission: '業務が提出された後は修正できません。提出する前に関連ファイルがアップロードされているかどうかを確認してください',
  AboutToUploadFiles: 'ファイルをアップロードしようとしています',
  SuccessfullyUploaded: 'アップロードに成功しました',
  RetrievalOfAssignedPermissions: '割り当てられた権限の取得',
  UploadResults: '結菓のアップロード',
  OnlyFilesFormatCanUploaded: '形式{0}のファイルのみをアップロードできます',
  VolumeAbnormalAndCannotUploaded: 'ファイルサイズが異常で、アップロードできません。',
  VolumeExceeds5mAndCannotUploaded: 'ファイルサイズが5Mを超えるため、アップロードできません。',
  VolumeExceeds20mAndCannotUploaded: 'ファイルサイズが20Mを超えるため、アップロードできません。',
  PlaceOfDeliverySeaport: '納品地（海港）',
  PlaceOfDeliveryAirport: '納品先（空港）',
  SailingDay: '出航の日',
  BusinessCreationDate: '取引作成日（起票日）',
  DeliveryStation: '納品ステーション',
  NoDocumentsDeclaringOrNonSpermWhaleUsers: 'ドキュメントが検索されませんでした。申告しているか、マッコウクジラ以外のユーザーである可能性があります。',
  HasContainerNoOrSealNoForSameEqTypeAndEqSize: 'このボックスにはボックス情報が関連付けられています。ボックス情報タブのボックスタイプを同期して変更しますか？',
  SeaEqAsyncToContainerTip: '関連する梱包情報が入力されました。まず梱包情報タブの梱包情報を削除してください！',
  TheSynchronizedFileCannotBeEdited: '同期されたファイルは編集できません',
  TheSynchronizedFileIsNotDeleted: '同期されたファイルは削除できません',
  CurrentBusinessStatusCannotBeSynchronized: '現在のビジネス状態は同期できません',
  TheSynchronizedExpensesCannotBeDeleted: '同期された費用は削除できません。まず費用の同期をキャンセルしてください。',
  CurrentlyThereIsNoSynchronizationCosts: '現在同期可能な費用はありません',
  ThereAreCurrentlyNoCancellableCharges: '現在キャンセル可能な料金はありません',
  NoCurrentChargesCanBeCancelled: '現在キャンセル可能な同期料金はありません',
  ChargeItemChangeTip: 'このチャージ名のデフォルト決済情報は現在のチャージと一緻しません。更新しますか？',
  SubscriptionInformation: '購読情報を受信する（分）会社を設定します',
  SetUpThePartners: '購読するパートナーを設定します',
  PleaseSelectAInformation: '運賃情報を選択してください。',
  ThisRateHasExpired: 'この運賃は期限切れです！',
  ExternalUsersCannotEdit: '外部ユーザーは編集できません。パートナーEコマースユーザーのタブに移動してください。',
  CommunicationConfirmation: '運賃の有効期限内に船期の要求に合う出航日が見つかりません。予約者と連絡して確認してください！',
  CombineTips: 'マスタを選択して組み合わせることはできません！',
  RepeatMblForSave: 'マスタ番号が重複しています。保存を確認しますか？',
  SystemAlert: 'システムアラート',
  NotRepeatOperation: '状態が変更されました。操作を繰り返さないでください。',
  FeesHaveBeenUsedForEditUnit: 'この単位コードにはすでに費用が使用されているので、変更できません！',
  TheChargingUnitIsUsedByAnExistingChargePlanForEditUnit: 'この課金単位コードはすでにチャージシナリオに使用されているため、変更できません！',
  ApplyChangeChargeNotThrough: '既に{0}、{1}できません。もう一度チェックしてください。',
  KingdeeNotExist: 'データを同期する必要がないか、ゴールデン蝶システムが存在しません',
  ByAdjustmentDate: '調整日別',
  ByBusinessDate: '取引日別',
  PleaseEnterTheFileType: 'ファイルタイプを入力してください',
  NotExportToImportBusiness: 'この注文は輸出から輸入への業務ではないので、同期できません！',
  JobNotOperateStatus: 'このシートは操作中の状態ではありません。同期できません！',
  JobShutOut: 'このオーダーはチェックアウトされているため、同期できません！',
  ChargeSyncSuccess: '料金の同期に成功しました！',
  NoSynchronizedFees: '同期できる費用がありません！',
  SaveColumnSettingsSameTime: '現在の表示列設定も保存',
  SaveScheme: 'スキームを保存',
  ReceivableCharge: '受取（費用）',
  PayableCharge: '対応（料金）',
  TruckingNotExist: '箱情報が存在しません！',
  SaveDisplayColumns: '表示列の保存',
  NoPermissionToAddExpense: '費用の追加権限がありません',
  NoPayableAddPermissionCannotImported: '支払費用を追加する権限がありません。費用をインポートできません',
  NoPayableAddPermissionOnlyImportReceivable: '買掛金の新規作成権限がありません。売掛金のみをインポートします',
  NoReceivableAddPermissionCannotImported: '売掛金の新規追加権限がありません。費用をインポートできません',
  NoReceivableAddPermissionOnlyImportPayable: '売掛金の新規追加権限がなく、買掛金のみをインポートします',
  OnlyRejectedBusinessesCanDelete: '拒否されたビジネスのみ削除できます',
  OnlyRejectedBusinessesCanDeleteIgnoreOther: '拒否されたビジネスのみが削除され、他のビジネスは無視されます',
  SuccessfullySubmittedXBusiness: '{num}個のビジネスが正常に送信されました',
  SuccessfullySubmittedXBusinessOtherIgnore: '{num}個の業務が正常に提出され、残りの業務の事前審査状態は提出条件を満たしていません',
  SuccessfullyRevokedXBusiness: '{num}件の業務が正常に取り下げられました',
  SuccessfullyRevokedXBusinessOtherIgnore: '{num}個の業務が正常に取り下げられ、残りの業務の予審状態は取り下げ条件を満たしていません',
  SuccessfullyConvertRealXBusiness: '正式業務への移行に成功しました{num}条',
  SuccessfullyConvertRealXBusinessOtherIgnore: '正式業務への移行に成功した{num}件、残りの業務の事前審査状態は正式業務への移行条件を満たしていません',
  ChargeSyncJobStateCheckFail: '費用同期ビジネス処理状況の検証に失敗しました',
  HaveChargeNotAllocatedAndtoContinue: 'チャージが割り当てられていません。チャージの同期を続行するかどうかを確認してください。',
  PartnerAlreadyExistPleaseSelectOfficialCustomer: 'パートナーはすでに存在します。正式なお客様で選択してください',
  PartnerHasMaintainedUndeToContinue: 'このパートナーは【{officeCode}】で維持されています。作成を続行しますか？',
  fileManagement: 'ファイル管理',
  FilterValue: 'フィルタ値',
  PriceAndNumIsNull: '単価、数量が空です。続行しますか？',
  SyncContainerSealNoToBillOfLading: '船荷証券梱包情報ボックスの封号を同期更新します',
  AssociatedBillOfLadingCannotDelete: '船荷証券が関連付けられており、削除できません',
  AssociatedBillOfLadingCannotRemove: '関連付けられた船荷証券は削除できません',
  SettlementObjectAccountPeriod: '決算対象期間',
  SettlementObjectAccountCredit: '決済対象の与信限度額',
  InvoiceHeaderDifferent: '請求先が一緻しません。続行しますか？',
  Agreement: '一緻する',
  NotAgreement: '不一緻',
  AllocationNature: '配分の性質',
  VirtualAllocation: '仮想割り当て',
  ActualSplit: '実際の分割',
  ShareTypeTip: '一緻:すべての費用の配賦タイプが一緻し、1つの費用の配賦タイプを変更すると、他の費用はすべて一緻に変更されます。不一緻:費用の配賦タイプは一緻しなくてもよく、配賦タイプを変更する場合は現在の費用の配賦タイプのみを変更します',
  VirtualAllocationAndActualSplitTip: '仮想分担:メインリストで請求書作成、請求書発行、支払申請、売上勘定などの決済を行う。レシートに分担された費用は仮想であり、表示のみ可能で、実質的な決済は行われません。実際の分割:分割後の費用は、請求書作成、請求書発行、支払申請、売上勘定などの決済を行います。メイン請求書の費用が決済されている場合、費用をレシートに分割することはできません。',
  ActualSplitWarn: '注意:実際に分割した後、メインリストの元の費用は保持されず、元に戻すことができません。慎重に操作してください！',
  CannotActualSplitTip: 'マスタの費用請求書作成、請求、支払申請、売上などの決済動作後に費用をレシートに分割できません！',
  SharedChargeTotal: '費用合計の配賦',
  DataHadUpdated: 'データが変更されました。もう一度クエリを実行してください',
  OpenSOPPanelNeedDoubleClick: 'SOPパネルを開くには、ビジネス状態をダブルクリックして再度呼び出します。',
  Operator: 'オペレータ',
  HaveInHand: '進行中',
  Exception: '例外',
  TerminalCompany: 'ターミナル会社',
  TerminalLocation: 'ターミナル会社',
  DeliveryAddress: '集荷先アドレス',
  TerminalAddress: '集荷先アドレス',
  TcDeliveryAddress: 'ターミナル会社集荷先情報',
  ResultLogUploadFaild: '結菓ログのクラウドストレージへのアップロードに失敗しました。再試行してください！',
  ConfigureDisplayColumns: '表示列の設定',
  AllNames: 'すべての名前',
  SelectedColumns: '選択された列',
  NoPermissionViewSecondaryTable: '二次テーブル情報を表示する権限がありません！',
  NoPermissionSetSecondaryTableColumns: '二次表の表示列を設定する権限がありません！',
  UpdateNoticeDetails: '更新通知【詳細】',
  DontRemindMeAgain: '次回は注意しない',
  NewInnerContractNo: '新規内部契約番号',
  EditInnerContractNo: '内部契約番号の修正',
  AreYouSureToCancelThisData: 'このデータを取り消しますか？',
  HasBeenUsedAndCannotEditContractNo: '使用されているため、契約番号を編集できません',
  HasBeenUsedAndCannotBeDeleted: '使用されているため削除できません',
  ApplicableRoute: '適用航路',
  IsEnable: '有効にするかどうか',
  ContractNoUseState: '約号の使用状態',
  NotUse: '未使用',
  Occupies: '占める',
  DataLoadingFailed: 'データのロードに失敗しました...',
  ExportExcel: 'Excelをエクスポート',
  ExportExcel2: 'EXCELをエクスポート',
  ExportPDF: 'PDFの書き出し',
  ExportWord: 'Export WORD',
  ExportPPT: 'Export PPT',
  NoDataIsCurrentlySelected: '現在データが選択されていません',
  SelectAll: 'すべて選択',
  CustomerSelfIssue: 'お客様は自分で注文します',
  Clear: 'クリア',
  QuickOfLadingNumberCustomsNumber: 'クイック検索:業務番号/船荷証券番号/通関番号',
  QuickMnemonicabbreviationChineseAndEnglishNames: 'ショートカット検索:ニーモニック/略称/中英名',
  InvoiceNumber: '/請求書番号',
  BusinessNumber: '/ビジネス番号',
  BillingNumber: '/請求書番号',
  PaymentApplicationNumber: '/支払申請番号',
  VerificationNumber: '/消込番号',
  ReconciliationNumber: '/請求書番号',
  ActualPaymentAndReceiptNumber: '/実績支払番号',
  DeliveryOrderNumber: '/注文番号を入れる',
  ProgramNumber: '/プログラム番号',
  QuickSearch: 'クイック検索',
  SearchBeRemovedNotFound: '削除するsearchItemが見つかりませんでした',
  Error3: 'エラー',
  AdvancedSchemeLoadingFailed01: '詳細クエリ構成スキームのロードに失敗しました01=:',
  TheFoundPleaseSelectScheme: 'このシナリオが見つかりません。別のシナリオを選択してください',
  AreYouWantToDelete: '本当に削除しますか？',
  Tip: 'ヒント',
  DeleteSchemeFailed: 'スキームの削除に失敗しました:',
  N1Exceeds4MBCannotUploaded: '1ファイルのサイズが4MBを超えているため、アップロードできません。',
  N1Exceeds20MBCannotUploaded: '1ファイルのサイズが20MBを超えるため、アップロードできません。',
  DeleteFileFailed: 'ファイルの削除に失敗しました！',
  Edit: '編集',
  SelectFile: 'ファイルの選択',
  DeleteFile: 'ファイルの削除',
  Upload: 'アップロード',
  UploadFile: 'ファイルのアップロード',
  FileName: 'ファイル名',
  FileType: 'ファイルタイプ',
  FileSize: 'ファイルサイズ',
  Uploader: 'アップロードする人',
  UploadTime: 'アップロード時間',
  UploadProgress: 'アップロードの進捗',
  Uploading2: 'アップロード中...',
  WaitingForUpload: 'アップロード待ち',
  DocumentCategory: 'ドキュメントカテゴリ',
  PlatformCustomerService: 'プラットフォームカスタマーサービス',
  Yes: '「はい」',
  No: 'いいえ',
  Confirm: '確認します',
  SaveColumnStatus: '列の状態を保存',
  ResetColumnStatus: '列の状態をリセット',
  SaveColumnStatusSuccess: '列状態の保存に成功しました',
  SaveColumnStatusFailed: '列の状態の保存に失敗しました',
  ResetColumnStatusSuccess: 'カラム状態のリセットに成功しました',
  ChatWindow: 'チャットウィンドウ',
  Internal: '内部',
  Communication: '「コミュニケーション」',
  InternalCommunication: 'Internal Communication',
  ExternalCommunication: 'External Communication',
  Customer: 'お客様',
  Reset: 'リセット',
  Search: '検索する',
  CurrentlySelectedItem: '現在選択されている項目:',
  Port: '港',
  State: '州',
  FileAbnormalCannotBeUploaded: 'ファイルサイズが異常で、アップロードできません。',
  File20MCannotBeUploaded: 'ファイルサイズが20Mを超えるため、アップロードできません。',
  UploadSuccessful: 'アップロードに成功しました',
  ImportFile: 'インポートファイル',
  PrintTemplate: '印刷テンプレート:',
  Code: 'コード',
  ChineseName: '氏名',
  EnglishName: '英語名',
  Country: '国',
  Region: 'エリア',
  Name2: '名前',
  StartDate: '開始日',
  To: 'へ',
  EndDate: '終了日',
  CurrentAuthorizations: '現在所有している権限',
  Refresh: 'リフレッシュ',
  User: 'ユーザー:',
  Authorization: '認可',
  Time: '時間:',
  AuthorizationUseHistory: 'ライセンス使用履歴:',
  AuthorizationFailed: '承認に失敗しました',
  SendTest: 'テストを送信',
  CurrentPersonalAuthorizationList: '現在の個人承認リスト',
  SendTo: '送信先:',
  Confirm2: 'OK',
  Cancel: 'キャンセル',
  Close: '閉じる',
  Open: '開く',
  AuthorizationItemDescription: '承認項目の説明',
  AuthorizationItem: '承認アイテム',
  AuthorizationStatus: '承認処理状況',
  NotSet: '設定されていません',
  StatusChangeTime: '状態変更時間',
  Operation: 'オペレーション',
  PleaseAddProductDescriptionHere: 'ここに製品の説明を追加してください',
  WeChatMessagePush: 'WeChatメッセージのプッシュ',
  MarqueeSwitch: '走馬灯スイッチ',
  PleaseInEmailPasswordauthorizationCode: 'メールアドレスのパスワード/認証コードを入力してください！',
  PleaseFillInRecipientEmail: '受信メールアドレスを入力してください！',
  EmailSettingsTestEmail: 'メールボックスの設定-テストメール',
  SendSuccessfully: '送信に成功しました',
  PaymentUponReceipt: '見付金放単',
  All: '全て',
  Unread: '未読',
  Read: '既読',
  MMDDDayHHMm: 'MM月DD日HH:mm',
  AssignSales: '売上の割当て',
  ReleaseSales: '売上をリリースする',
  ReviewSales: '売上のレビュー',
  SuccessfullyGrabCustomer: '顧客獲得に成功しました',
  GrabCustomerFailed: '顧客の奪取に失敗しました',
  ScheduleReminder: 'スケジュール・リマインダー',
  CustomerExpirationReminder: '顧客期限切れ通知',
  BusinessReviewReminder: 'ビジネスレビュー通知',
  CustomsDeclarationReminder: '通関通知',
  AbnormalHandlingOfBox: '箱の例外処理',
  DeparturePickUpContainerWarning: '出発ロッカー警告',
  BoxArrivingAtFactoryWarning: '箱到着警告',
  BoxLeavingFactoryWarning: '箱が工場から離れる警告',
  CustomsReleaseWarning: '税関リリース警告',
  TerminalReleaseWarning: '埠頭リリース警告',
  BoardingWarning: '乗船警告',
  DepartureWarning: '出港警告',
  ArrivalWarning: '到着警報',
  ReturningBoxWarning: 'ボックス返却警告',
  SystemArrearsReminder: 'システム料金未払いのお知らせ',
  ChangeReviewAndApprovalReminder: '変更費用レビュー承認通知',
  DefaultMessage: 'デフォルトメッセージ',
  Message: 'システムメッセージです',
  SelectTemplate: 'テンプレートを選択',
  PleaseSelectTheExportTemplate: 'エクスポートテンプレートを選択してください',
  Upload0UploadFailure0: 'アップロード成功:{0}個、アップロード失敗:{1}個。',
  SuccessfulFailure0ConfirmSave: 'アップロード成功:{0}個、失敗:{1}個、保存しますか？',
  Only0FormatCanUploaded: '{0}形式のファイルのみをアップロードできます',
  YouToOpenTheModule: '【{0}】モジュールを開く権限がありません',
  Upload0UploadFailed0: 'アップロード成功:{0}個、アップロード失敗:{1}個。',
  All2: '（すべて）',
  NumberOfPiecescommissionactual: '件数（委/実）',
  LetterOfCreditTerms: '信用状条項',
  N4InsuranceCompletion: '4保険加入完了',
  N2Inquiry: '2引合',
  SensitiveWords: '敏感な単語',
  FreightRateDetails: '運賃の詳細',
  Manufacturer: 'メーカー',
  ShipName: '船名:',
  IsItCorrect: '正しいかどうか。',
  BoxReturnedFromTheArea: '港区からの箱物情報:',
  CurrentlyStatusAndCannotDeleted: '現在編集中で削除できません',
  ChineseAbbreviationOfTheCompany: '会社の中国語略称:',
  TheTheCompanyCannotEmpty: '会社の英語略称は空にできません',
  Voyage: '航程:',
  ShippingSchedule: '船期:',
  PortOfDepartureUpdate: '出荷港の更新',
  DestinationPortUpdate: '目的港の更新',
  ChatInside: '内部コミュニケーション',
  ChatByClient: '外部コミュニケーション',
  DoubleClickToSelectState: 'テキストボックスをダブルクリックして処理状況クエリを選択',
  StateQuery: '処理状況クエリ',
  EdiStateQuery: 'EDI処理状況クエリ',
  BookingEdiSendType: 'Booking EDI type',
  BookingEdiSendTime: 'Booking EDI time',
  imConnecting: 'Trying to connect.....',
  imConnectFailed: 'Session connection failed. Please close and reopen.',
  SwitchBranchAndOpenModuleTipAllEdit: 'Please save the data and close the opened modules before switching branches. Currently, {0} modules are open. Do you want to close all modules?',
  SwitchBranchAndOpenModuleTipNotEdit: 'Please close the modules that have already been opened before switching branches. Currently, {0} modules are open. Do you want to close all of them?',
  SwitchBranchAndOpenModuleTipPartEdit: 'Please save data and close modules before switching branches. Currently, {0} open modules have not been saved or closed. Do you want to close all of them?',
  PrintRecordsOverLimitTip: 'The number of printed records exceeds the system limit. Do you want to export them directly?',
  PrintRecordsOver100Tip: 'If the number of printed records exceeds 100, the loading time may be longer. Would you like to export it directly?',
  ContinuePreview: 'Continue preview',
  NotSupported: '{0}マルチプレクション・データ・スプリット表示はサポートされていません',
  PleaseFillInCorrectly: '多距離情報を正しく記入してください。中に空きがあることは許されません',
  DoNotEmpty: '1つのデータを空にすることはできません',
  AirlineReplacement: '一路航空司が変更され、出発港の空港情報（空港、実際の入場時間、実際の積載時間、予定離陸時間、実際の離陸時間）を空にし、データを再取得する',
  AirlineReplacement1: '1.変更された航空会社は、サブスクリプションをサポートする航空会社のリストに含まれていないため、データを取得できません',
  AirlineReplacement2: '2.一路航空司は変更が発生し、空港情報（空港、実際の入場時間、実際の積載時間、予定離陸時間、実際の離陸時間）を空にする',
  AirlineReplacementLast: '最終便の航空会社は変更され、目的港の空港情報（到着予定時間、到着予定時間、受領予定時間、荷下ろし実績時間、到着実績通知時間、集荷実績時間）をクリアし、データを再取得する',
  AirlineReplacementLast2: '2.最終便の航空会社が変更され、目的港の空港情報（到着予定時刻、到着予定時刻、荷受実績時刻、荷卸実績時刻、到着実績通知時刻、荷受実績時刻）をクリアする',
  ViewShippingTracking: '異なる航空会社が複数存在する場合は、データは【運航追跡】ページを参照してください',
  IntermediateAirline: '変更された航空会社は、サブスクリプションをサポートする航空会社のリストに含まれていないため、2次データを取得できません',
  ExportingPleaseWait: 'Exporting file, please wait',
  ExportTakePlaceInBackground: 'You can leave the page and export will take place in the background',
  CompletionDownloadMessageReminderInRightCorner: 'After completion, please download it from the "Message Reminder" {0} in the upper right corner.',
  FileExportCompletionReminder: 'File export completion reminder',
  SyncPartnerToFinanceCodeReminder: 'Reminder of customer/supplier code import completion',
  NoNewPermissionsForFees: 'There are no new permissions for fees',
  NoPayChargesImport: 'You don\'t have the Payable Charges New privilege and you can\'t import expenses',
  NoCostChargesImport: 'You don\'t have the Chargeable New privilege and no fees to import',
  OnlyCostChargesImport: 'You do not have the Add Payable Fees permission, only import the Payable Fees',
  OnlyPayChargesImport: 'You don\'t have the Add Fees due permission, only import the Payable Charges',
  ConfirmDeleteN: 'Are you sure to delete this {0} record?',
  AffiliatedBranchStyle: 'Style of affiliated branch',
  DisplayByOrganizationalStructure: 'Display by organizational structure',
  AllDisplay: 'All display',
  FileView: 'File View',
  NotPermissionToEditFilesByOtherUsers: 'Insufficient permissions: Do not have permission to edit files uploaded by other users',
  NotMatchingTheCostOfTheProjectCanBeDelete: 'There are no matching expense items to delete.',
  ThisPartnerDoesNotSupportEnterReceivableFees: 'This Partner Does Not Support Enter Receivable Fees',
  ThisPartnerDoesNotSupportEnterPayableFees: 'This Partner Does Not Support Enter Payable Fees',
  Can_Changed: 'Can be changed',
  Customer_Service: 'コールセンター',
  Documentation_Department: '単証担当部門',
  Countries_Regions_Destination: '目的地の国',
  CargoDocAndContainerQWTNotSame: 'The packing information of the bill of lading is inconsistent with the business packing information!',
  Some_Items_Have_Expired: '一部の費用請求項目は失効し、抄録に失敗しました',
  SentDestinationPortAgentTip: 'Notification has been sent to the destination port agent file',
  SendFileVerification: 'Send file verification',
  SendFileVerificationSuccessTip: "The file verification was successful. Please click 'Next' to continue sending the email, or 'Cancel'",
  SendFileVerificationExceptionTip: "The file verification was exception. Please click 'Next' to continue sending the email, or 'Cancel'",
  Validating: 'Validating',
  MasterCheckExist: 'Main ticket verification: {0} exists',
  SmallCheckExist: 'Small ticket verification: {0} exists',
  EmailAttachments: 'Email attachments',
  DeleteAttachTip: 'Are you sure you want to delete this attachment?',
  LocalEmailSentSuccess: 'Successfully sent via local email?',
  LocalEmailTooLarge: 'The email content is too large to redirect to the local mailbox!',
  Lack: 'Lack',
  FileDragArea: 'Drag and drop files to this area to upload',
  EnterKeyword: 'Enter Keyword',
  ClearSelectedItems: 'Clear selected items',
  ManifestFileNumBox: 'The number of MANIFEST files is equal to the number of boxes',
  ManifestFileNumNotEqualBox: '[Box Quantity]: {0}/[MAINFIEST] Number of Files: {1}, MANIFEST Files and Box Quantity Inconsistent',
  TheSelectedDataIsIgnoredSuccessfully: '選択済みデータの無視に成功しました',
  SelectedDataHasBeenBatchProcessedSuccessfully: '選択済みデータのキャンセル無視に成功しました',
  ThereAreNoNegligibleCosts: '無視できる費用はありません',
  ThereAreNoFeesThatCanBeEliminated: '無視するキャンセル料はありません',
  OnlyUnRead: '未読を読むだけです',
  AllMarksRead: 'すべて既読マークを付けます',
  MessageConfig: 'メッセージ設定です',
  SaleProductCodeCannotBeNull: 'Allow Sale Product cannot be null',
  FullOrInsideCannotBeNull: 'Full Or Inside cannot be null',
  NotNullForMapping: 'The basic tab fields "【 Allow Sale Product 】 and 【 Full Or Inside 】 can not be empty". Please enter and then select the cost',
  DifferentJobOrBusinessFieldValues: 'The selected service contains multiple different jobs or service field values. If this parameter is not set, the original job and field values are retained',
  PreserveOriginalValue: 'Preserve original value',
  SelectSynchronizedFields: '同期フィールドの選択',
  SynchronizedFields: '同期フィールド',
  RunSuccess: '実行に成功しました',
  RunFail: '実行に失敗しました',
  PleaseUpload: '元の値は空です。ファイルをアップロードしてください',
  CodeTip: '1、ここのコード言語：javascript' +
      '\n2、デフォルトの元の処理対象オブジェクト名は：result. (resultのすべてが元の値のJSONオブジェクトです)' +
      '\n3、最初の要素を取得するには、： result[0]. (要素0番目からカウント)' +
      '\n4、識別フィールドの値を取得するには、：result[0].text.data[\'ほうそう\']' +
      '\n5、パッケージの値を変更するには、：result[0].text.data[\'ほうそう\'] =\'PPK\'' +
      '\n6、パッケージ内のすべての「P」の値を置換するには、：result[0].text.data[\'ほうそう\'] =result[0].text.data[\'ほうそう\'].replaceAll(\'P\',\'B\');',
  BlIsIssued: '船荷証券はすでに発行された',
  NoVirtualHBLTip: '本業務には形式発注がありませんので、形式発注にチェックを入れてから作業を進めてください。',
  NoVirtualHBLAuthTip: 'このページに署名する権限がなくて、管理者に連絡して形式を配置して依頼する権限の後で使用します!',
  FieldValueCannotBeNull: '{0}は空にできません',
  ImportFailedFileNameNotMatch: 'インポートに失敗しました。ファイル名はISF 5またはISF 10の先頭ではありません',
  ISF5File: 'Misf 5テンプレート',
  ISF10File: 'Misf 10テンプレート',
  BookingLabel: 'Booking label',
  BatchPurchasePriceLock: '買取価格がロックされていない業務をチェックして操作してください。',
  BatchPurchasePriceUnLock: '買取価格がロックされている業務をチェックして操作してください。',
  BatchSellingPriceUnLock: '販売価格がロックされている業務をチェックして操作してください。',
  BatchSellingPriceLock: '販売価格がロックされていない業務をチェックして操作してください。',
  NotPermissionToViewFiles: '表示権限のないファイルが存在します{0},メールを送信できません',
  ContainerTotalNeedEqual: 'コンテナ【アウトソーシング件数】【内包装件数】【重量】【純重量】合計数は特殊貨物番号内の総数と一致する必要がある',
  PackingAddNotRepeat: '選択された梱包情報が追加されました。繰り返し追加しないでください',
  vesselNotFound: '船名は直接入力できませんので、チェックして再入力してください！',
  exportToImportNotUpdatedVessel: '輸出から輸入転送の場合、予約タブで船名は変更不可です。',
  voyageNotFound: '航空便は直接入力できませんので、チェックして再入力してください！',
  exportToImportNotUpdatedVoyage: '輸出から輸入転送の場合、予約タブで航次は変更不可です。',
  smallReceiptNotVoyage: 'マスタービル以下のサブ伝票ではフライトを編集できません',
  mblOnlyNotFreightTermHBL: 'ダイレクトビルでない場合、HBLの運送条件を変更できません',
  notUpdateFreightTermHbl: '輸出から輸入取引ではHBLの運送条件を更新できません',
  otherButtonNotUpdate: '他のボタンが選択されていないため変更不可',
  notUpdateDischargingPortDoor: '荷揚港サービス未選択の場合、荷揚港配車は選択不可',
  notUpdateDispatchingPlaceCode: '本伝票では発地コード（配送場所）フィールドが存在しないため変更不可',
  notUpdatePacking: '輸出から輸入取引では梱包フィールドを更新できません',
  notUpdateDispatchingPlaceExport: '輸出から輸入取引では発地フィールドを更新できません',
  notUpdateDispatchingPlace: '本伝票ではB/L発地フィールドが存在しないため変更不可',
  notUpdateOther: '本伝票ではその他セクションが存在しないため変更不可',
  notUpdateCustomsDeclarationType: '通関が未選択の場合、通関タイプフィールドは変更不可です！',
  haveChargeNotUpdateCustomsDeclarationType: '料金が存在する場合、通関タイプフィールドは変更不可です！',
  packingRequired: '包装フィールドは必須項目です、空にできません！',
  freightTermHBLRequired: 'HBL運送条件フィールドは必須項目です、空にできません！',
  seBookingTermRequired: '約定性質フィールドは必須項目です、空にできません！',
  aeBookingTermRequired: '予約タイプは必須項目であり、空にすることはできません！',
  noUpdateCustomClaim2: '通関方法が委託ではないため、通関タイプを変更できません！',
  transportLineRequired: '輸送ルートは必須項目であり、空にすることはできません！',
  noUpdateSmallTicketTransportLine: 'マスタビルがある小票の輸送ルートは変更できません！',
  departureStationRequired: '出発駅は必須項目であり、空にすることはできません！',
  noUpdateSmallTicketDepartureStation: 'マスタビルがある小票の出発駅は変更できません！',
  destinationStationRequired: '到着駅は必須項目であり、空にすることはできません！',
  noUpdateSmallTicketDestinationStation: 'マスタビルがある小票の到着駅は変更できません！',
  noUpdateSmallTicketForwardingAgent: 'マスタビルがある小票の運送代理店は変更できません！',
  businessLock: '業務がロックされており、変更できません',
  businessNotEmpty: 'B/L番号は空にできません',
  businessNotUpdate: 'B/Lは変更条件を満たしていません',
  notOperateNotUpdateQuantity: '数量を編集する権限がありません',
  notOperateNotUpdateWeight: '総重量を編集する権限がありません',
  notOperateNotUpdateCubage: '容積を編集する権限がありません',
  notOperateNotUpdatePackingName: '包装表示名を編集する権限がありません',
  notOperateNotUpdatePaymentPlaceBL: 'HBL支払場所フィールドは編集できません',
  notOperateNotUpdateRequestReleaseState: 'B/L解放申請処理状況は編集できません',
  notOperateNotUpdateFreightTermHBL: '運送条項は編集できません',
  notOperateNotUpdateSoNo: 'SO番号は編集できません',
  notOperateNotUpdateLoadingPortCode: '積み込み港は編集できません',
  notOperateNotUpdateDischargingPortCode: '揚げ地港は編集できません',
  notOperateNotUpdateVesselVoyage: '船名/航海番号は編集できません',
  notOperateNotUpdateDestinationPortCode: '仕向け地港は編集できません',
  notOperateNotUpdateReleaseDate: '解放日は編集できません',
  notOperateNotUpdateWithHoldDate: '保留日は編集できません',
  notOperateNotUpdateSurrenderedNo: '解放番号は編集できません',
  notOperateNotUpdateWithHoldReason: '保留理由は編集できません',
  selectRequirement: '操作要件をダブルクリックして選択',
  DataGroup: 'Data Group',
  CloseRefreshNeedMannulUpdate: '自動更新がオフになっているときは、データを更新するために手動で[更新]をクリックする必要があります！',
  RefreshRule: 'ルールを更新する:',
  NodeRecord: 'ノードレコード:',
  HomePageNotRefreshData: 'ホームページに入るとデータは自動的に更新されません',
  DisplayLastClickNode: '最後にクリックされたノードを表示します',
  RetainQueryCondition: 'ノードのクエリ条件を保持する',
  N0VerificationPassed: '[{0}] 検証に合格しました',
  ConsigneeCompanyName: '荷受人企業名',
  TaskBoard: 'タスクボード：',
  AlertNode: '警告ノード：',
  DoOfQueryResultsTemplates: '検索結果の数に基づいて表示せず、テンプレートを切り替える際に検索条件をリセットする',
  SendPortAgentByNumber: '仕向け港エージェントへ送付 - コンテナ番号別',
  SendAgentByCaseNumber: 'セットリスト送信代理 - ケース番号別',
  SetOrderAgency: 'セット注文代理',
  LastSentTime: '前回送信日時',
  BusinessOperationsCannotBeModified: '「審査済み」「提出済み」「事前提出」「提出中」のビジネス処理状況に関連付けられた貨物スペースがある場合、一括船変更では修正できません。個別に修正する必要があります。',
  UpdateVoyageInfoMessage: '航次情報を更新します。これにより、海上輸出業務の関連情報も同時に更新されます。確認後、メール通知が送信されます:',
  updateBatchTips: '航次情報を更新すると、海上輸出業務の関連情報も同時に更新されます。確認しますか？',
  batchUpdateShipSuccess: '一括船舶転送が成功しました',
  ShippingCompanyCannotBeModifiedBylclMasterUuid: 'LCLマスタービルが空でない場合、船会社は変更できません。',
  ShippingCompanyCannotBeModifiedByCharge: '船会社に費用が紐付いている場合、変更は許可されません。',
  ShippingCompanyNotExist: '船会社が存在しません',
  AirCompanyCannotBeModifiedBylclMasterUuid: 'LCLマスタービルが空でない場合、航空会社は変更できません',
  AirCompanyCannotBeModifiedByCharge: '航空会社に費用が紐付いている場合、変更は許可されません',
  AirCompanyNotExist: '航空会社が存在しません',
  SeToSiCannotBeUpdatedToShippingCompany: 'クロステナントの輸出から輸入業務では船会社の変更は許可されていません',
  TheDesignatedFreightForwarderCannotBeModified: '指定貨物代理店は修正できません。',
  TheValueOfTheDesignatedFreightForwarderIsIncorrect: '発注代理店の値が間違っています。',
  CustomPageSettings: 'カスタムページ設定',
  EnterCustomPageSettings: 'カスタムページ設定に移動する',
  Russian: 'ロシア語',
  Vietnamese: 'ベトナム語',
  Thai: 'タイ語',
  SelectTransshipmentStatusErrorPrompt: 'バッチでの正操作業務の変更のみをサポートしています',
  PleaseSelectTheMainTicketForModification: 'マスターチケットを選択して修正してください',
  NoAccessPermission: 'アクセス権限なし'
}
